import { jsx as m, Fragment as pt, jsxs as z } from "react/jsx-runtime";
import * as c from "react";
import T, { createContext as wn, useContext as xn, useState as Pe, useCallback as Ot, useMemo as Dt, useLayoutEffect as yi, useEffect as be, useRef as At, forwardRef as ne, useReducer as bi } from "react";
import * as Ft from "react-dom";
import kr, { createPortal as $r } from "react-dom";
const wi = wn(null), xi = () => {
  const e = xn(wi);
  if (!e)
    throw new Error("ActionSheet 컴포넌트는 ActionSheet Provider 내부에서 사용되어야 합니다.");
  return e;
};
function Ei(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = Ei(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function Ci() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = Ei(e)) && (r && (r += " "), r += t);
  return r;
}
const Lr = "-", rl = (e) => {
  const t = il(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(Lr);
      return a[0] === "" && a.length !== 1 && a.shift(), Si(a, t) || ol(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const u = n[s] || [];
      return a && r[s] ? [...u, ...r[s]] : u;
    }
  };
}, Si = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Si(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Lr);
  return (s = t.validators.find(({
    validator: a
  }) => a(i))) == null ? void 0 : s.classGroupId;
}, Co = /^\[(.+)\]$/, ol = (e) => {
  if (Co.test(e)) {
    const t = Co.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, il = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return sl(Object.entries(e.classGroups), n).forEach(([i, s]) => {
    sr(s, r, i, t);
  }), r;
}, sr = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : So(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (al(o)) {
        sr(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, s]) => {
      sr(s, So(t, i), n, r);
    });
  });
}, So = (e, t) => {
  let n = e;
  return t.split(Lr).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, al = (e) => e.isThemeGetter, sl = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([s, a]) => [t + s, a])) : i);
  return [n, o];
}) : e, cl = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, s) => {
    n.set(i, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}, Ri = "!", ll = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length, s = (a) => {
    const u = [];
    let l = 0, d = 0, f;
    for (let g = 0; g < a.length; g++) {
      let y = a[g];
      if (l === 0) {
        if (y === o && (r || a.slice(g, g + i) === t)) {
          u.push(a.slice(d, g)), d = g + i;
          continue;
        }
        if (y === "/") {
          f = g;
          continue;
        }
      }
      y === "[" ? l++ : y === "]" && l--;
    }
    const p = u.length === 0 ? a : a.substring(d), v = p.startsWith(Ri), w = v ? p.substring(1) : p, h = f && f > d ? f - d : void 0;
    return {
      modifiers: u,
      hasImportantModifier: v,
      baseClassName: w,
      maybePostfixModifierPosition: h
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: s
  }) : s;
}, ul = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, dl = (e) => ({
  cache: cl(e.cacheSize),
  parseClassName: ll(e),
  ...rl(e)
}), fl = /\s+/, pl = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = [], s = e.trim().split(fl);
  let a = "";
  for (let u = s.length - 1; u >= 0; u -= 1) {
    const l = s[u], {
      modifiers: d,
      hasImportantModifier: f,
      baseClassName: p,
      maybePostfixModifierPosition: v
    } = n(l);
    let w = !!v, h = r(w ? p.substring(0, v) : p);
    if (!h) {
      if (!w) {
        a = l + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (h = r(p), !h) {
        a = l + (a.length > 0 ? " " + a : a);
        continue;
      }
      w = !1;
    }
    const g = ul(d).join(":"), y = f ? g + Ri : g, E = y + h;
    if (i.includes(E))
      continue;
    i.push(E);
    const x = o(h, w);
    for (let b = 0; b < x.length; ++b) {
      const S = x[b];
      i.push(y + S);
    }
    a = l + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function ml() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Ti(t)) && (r && (r += " "), r += n);
  return r;
}
const Ti = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Ti(e[r])) && (n && (n += " "), n += t);
  return n;
};
function hl(e, ...t) {
  let n, r, o, i = s;
  function s(u) {
    const l = t.reduce((d, f) => f(d), e());
    return n = dl(l), r = n.cache.get, o = n.cache.set, i = a, a(u);
  }
  function a(u) {
    const l = r(u);
    if (l)
      return l;
    const d = pl(u, n);
    return o(u, d), d;
  }
  return function() {
    return i(ml.apply(null, arguments));
  };
}
const q = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Ni = /^\[(?:([a-z-]+):)?(.+)\]$/i, gl = /^\d+\/\d+$/, vl = /* @__PURE__ */ new Set(["px", "full", "screen"]), yl = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, bl = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, wl = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, xl = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, El = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Ie = (e) => ut(e) || vl.has(e) || gl.test(e), Ve = (e) => ht(e, "length", Ml), ut = (e) => !!e && !Number.isNaN(Number(e)), _n = (e) => ht(e, "number", ut), St = (e) => !!e && Number.isInteger(Number(e)), Cl = (e) => e.endsWith("%") && ut(e.slice(0, -1)), H = (e) => Ni.test(e), Ue = (e) => yl.test(e), Sl = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Rl = (e) => ht(e, Sl, Pi), Tl = (e) => ht(e, "position", Pi), Nl = /* @__PURE__ */ new Set(["image", "url"]), Pl = (e) => ht(e, Nl, Dl), Al = (e) => ht(e, "", Ol), Rt = () => !0, ht = (e, t, n) => {
  const r = Ni.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, Ml = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  bl.test(e) && !wl.test(e)
), Pi = () => !1, Ol = (e) => xl.test(e), Dl = (e) => El.test(e), Il = () => {
  const e = q("colors"), t = q("spacing"), n = q("blur"), r = q("brightness"), o = q("borderColor"), i = q("borderRadius"), s = q("borderSpacing"), a = q("borderWidth"), u = q("contrast"), l = q("grayscale"), d = q("hueRotate"), f = q("invert"), p = q("gap"), v = q("gradientColorStops"), w = q("gradientColorStopPositions"), h = q("inset"), g = q("margin"), y = q("opacity"), E = q("padding"), x = q("saturate"), b = q("scale"), S = q("sepia"), N = q("skew"), C = q("space"), R = q("translate"), O = () => ["auto", "contain", "none"], I = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", H, t], D = () => [H, t], A = () => ["", Ie, Ve], P = () => ["auto", ut, H], F = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], k = () => ["solid", "dashed", "dotted", "double", "none"], V = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], _ = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], M = () => ["", "0", H], j = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], G = () => [ut, H];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Rt],
      spacing: [Ie, Ve],
      blur: ["none", "", Ue, H],
      brightness: G(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ue, H],
      borderSpacing: D(),
      borderWidth: A(),
      contrast: G(),
      grayscale: M(),
      hueRotate: G(),
      invert: M(),
      gap: D(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Cl, Ve],
      inset: $(),
      margin: $(),
      opacity: G(),
      padding: D(),
      saturate: G(),
      scale: G(),
      sepia: M(),
      skew: G(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", H]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ue]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": j()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": j()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...F(), H]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: I()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": I()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": I()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", St, H]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: $()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", H]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: M()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: M()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", St, H]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Rt]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", St, H]
        }, H]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": P()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": P()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Rt]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [St, H]
        }, H]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": P()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": P()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ..._()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ..._(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [..._(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [E]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [E]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [E]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [E]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [E]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [E]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [E]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [E]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [E]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [C]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [C]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", H, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [H, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [H, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ue]
        }, Ue]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [H, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [H, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [H, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [H, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ue, Ve]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", _n]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Rt]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", H]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ut, _n]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Ie, H]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", H]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", H]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...k(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Ie, Ve]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Ie, H]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", H]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", H]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...F(), Tl]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Rl]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Pl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [w]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [w]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [w]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...k(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: k()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...k()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ie, H]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Ie, Ve]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: A()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Ie, Ve]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ue, Al]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Rt]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...V(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": V()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ue, H]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", H]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: G()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", H]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: G()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", H]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [b]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [b]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [b]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [St, H]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [R]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [R]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [N]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [N]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", H]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", H]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", H]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ie, Ve, _n]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, _l = /* @__PURE__ */ hl(Il);
function W(...e) {
  return _l(Ci(e));
}
const Ai = T.forwardRef(
  ({ children: e, className: t, disabled: n, onClick: r, ...o }, i) => {
    const { open: s, onOpenChange: a, contentId: u, triggerId: l } = xi(), d = (f) => {
      n || a(!s), r == null || r(f);
    };
    return /* @__PURE__ */ m(
      "button",
      {
        ref: i,
        id: l,
        type: "button",
        disabled: n,
        "aria-expanded": s,
        "aria-controls": u,
        "aria-haspopup": "dialog",
        className: W(
          // 기본 버튼 스타일
          "inline-flex items-center justify-center rounded-lg px-4 py-2",
          "typography-ui-16m text-gray-900",
          "border border-gray-200 bg-white",
          "transition-colors duration-200",
          // 호버/포커스 상태
          "hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500",
          // 비활성화 상태
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white",
          t
        ),
        onClick: d,
        ...o,
        children: e
      }
    );
  }
);
Ai.displayName = "ActionSheetTrigger";
const kl = (e = {}) => {
  const { open: t, onOpenChange: n, defaultOpen: r = !1 } = e, o = t !== void 0, [i, s] = Pe(r), a = o ? t : i, u = Ot(
    (l) => {
      o || s(l), n == null || n(l);
    },
    [o, n]
  );
  return {
    open: a,
    onOpenChange: u,
    isControlled: o
  };
}, $l = ({ children: e, ...t }) => {
  const { open: n, onOpenChange: r } = kl(t), o = Dt(() => {
    const a = Math.random().toString(36).substr(2, 9);
    return {
      contentId: `actionsheet-content-${a}`,
      triggerId: `actionsheet-trigger-${a}`
    };
  }, []), i = T.Children.toArray(e).some(
    (a) => T.isValidElement(a) && a.type === Ai
  ), s = Dt(
    () => ({
      open: n,
      onOpenChange: r,
      contentId: o.contentId,
      triggerId: i ? o.triggerId : void 0
    }),
    [n, r, o.contentId, o.triggerId, i]
  );
  return /* @__PURE__ */ m(wi.Provider, { value: s, children: e });
};
$l.displayName = "ActionSheet";
function Ro(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ll(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Ro(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Ro(e[o], null);
        }
      };
  };
}
var Mi = c.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = c.Children.toArray(n), i = o.find(Bl);
  if (i) {
    const s = i.props.children, a = o.map((u) => u === i ? c.Children.count(s) > 1 ? c.Children.only(null) : c.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ m(cr, { ...r, ref: t, children: c.isValidElement(s) ? c.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ m(cr, { ...r, ref: t, children: n });
});
Mi.displayName = "Slot";
var cr = c.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (c.isValidElement(n)) {
    const o = Vl(n);
    return c.cloneElement(n, {
      ...Wl(r, n.props),
      // @ts-ignore
      ref: t ? Ll(t, o) : o
    });
  }
  return c.Children.count(n) > 1 ? c.Children.only(null) : null;
});
cr.displayName = "SlotClone";
var Fl = ({ children: e }) => /* @__PURE__ */ m(pt, { children: e });
function Bl(e) {
  return c.isValidElement(e) && e.type === Fl;
}
function Wl(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Vl(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function To(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function tt(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = To(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : To(e[o], null);
        }
      };
  };
}
function Q(...e) {
  return c.useCallback(tt(...e), e);
}
function Xe(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = c.createContext(s), u = n.length;
    n = [...n, s];
    const l = (f) => {
      var y;
      const { scope: p, children: v, ...w } = f, h = ((y = p == null ? void 0 : p[e]) == null ? void 0 : y[u]) || a, g = c.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ m(h.Provider, { value: g, children: v });
    };
    l.displayName = i + "Provider";
    function d(f, p) {
      var h;
      const v = ((h = p == null ? void 0 : p[e]) == null ? void 0 : h[u]) || a, w = c.useContext(v);
      if (w)
        return w;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [l, d];
  }
  const o = () => {
    const i = n.map((s) => c.createContext(s));
    return function(a) {
      const u = (a == null ? void 0 : a[e]) || i;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: u } }),
        [a, u]
      );
    };
  };
  return o.scopeName = e, [r, Ul(o, ...t)];
}
function Ul(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: u, scopeName: l }) => {
        const f = u(i)[`__scope${l}`];
        return { ...a, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function L(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
var Te = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, zl = c[" useInsertionEffect ".trim().toString()] || Te;
function Bt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, i, s] = Hl({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, u = a ? e : o;
  {
    const d = c.useRef(e !== void 0);
    c.useEffect(() => {
      const f = d.current;
      f !== a && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = a;
    }, [a, r]);
  }
  const l = c.useCallback(
    (d) => {
      var f;
      if (a) {
        const p = jl(d) ? d(e) : d;
        p !== e && ((f = s.current) == null || f.call(s, p));
      } else
        i(d);
    },
    [a, e, i, s]
  );
  return [u, l];
}
function Hl({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = c.useState(e), o = c.useRef(n), i = c.useRef(t);
  return zl(() => {
    i.current = t;
  }, [t]), c.useEffect(() => {
    var s;
    o.current !== n && ((s = i.current) == null || s.call(i, n), o.current = n);
  }, [n, o]), [n, r, i];
}
function jl(e) {
  return typeof e == "function";
}
function Kl(e) {
  const t = c.useRef({ value: e, previous: e });
  return c.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Oi(e) {
  const [t, n] = c.useState(void 0);
  return Te(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, l = Array.isArray(u) ? u[0] : u;
          s = l.inlineSize, a = l.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({ width: s, height: a });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function Gl(e, t) {
  return c.useReducer((n, r) => t[n][r] ?? n, e);
}
var nt = (e) => {
  const { present: t, children: n } = e, r = Yl(t), o = typeof n == "function" ? n({ present: r.isPresent }) : c.Children.only(n), i = Q(r.ref, Xl(o));
  return typeof n == "function" || r.isPresent ? c.cloneElement(o, { ref: i }) : null;
};
nt.displayName = "Presence";
function Yl(e) {
  const [t, n] = c.useState(), r = c.useRef(null), o = c.useRef(e), i = c.useRef("none"), s = e ? "mounted" : "unmounted", [a, u] = Gl(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const l = Zt(r.current);
    i.current = a === "mounted" ? l : "none";
  }, [a]), Te(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const p = i.current, v = Zt(l);
      e ? u("MOUNT") : v === "none" || (l == null ? void 0 : l.display) === "none" ? u("UNMOUNT") : u(d && p !== v ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), Te(() => {
    if (t) {
      let l;
      const d = t.ownerDocument.defaultView ?? window, f = (v) => {
        const h = Zt(r.current).includes(v.animationName);
        if (v.target === t && h && (u("ANIMATION_END"), !o.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, p = (v) => {
        v.target === t && (i.current = Zt(r.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(l), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: c.useCallback((l) => {
      r.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function Zt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Xl(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
// @__NO_SIDE_EFFECTS__
function ql(e) {
  const t = /* @__PURE__ */ Zl(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(Jl);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ m(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ m(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Zl(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = tu(o), a = eu(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? tt(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Ql = Symbol("radix.slottable");
function Jl(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ql;
}
function eu(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function tu(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var nu = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], re = nu.reduce((e, t) => {
  const n = /* @__PURE__ */ ql(`Primitive.${t}`), r = c.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(u, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Di(e, t) {
  e && Ft.flushSync(() => e.dispatchEvent(t));
}
var En = "Checkbox", [ru, gv] = Xe(En), [ou, iu] = ru(En), Ii = c.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: s,
      disabled: a,
      value: u = "on",
      onCheckedChange: l,
      form: d,
      ...f
    } = e, [p, v] = c.useState(null), w = Q(t, (b) => v(b)), h = c.useRef(!1), g = p ? d || !!p.closest("form") : !0, [y, E] = Bt({
      prop: o,
      defaultProp: i ?? !1,
      onChange: l,
      caller: En
    }), x = c.useRef(y);
    return c.useEffect(() => {
      const b = p == null ? void 0 : p.form;
      if (b) {
        const S = () => E(x.current);
        return b.addEventListener("reset", S), () => b.removeEventListener("reset", S);
      }
    }, [p, E]), /* @__PURE__ */ z(ou, { scope: n, state: y, disabled: a, children: [
      /* @__PURE__ */ m(
        re.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": je(y) ? "mixed" : y,
          "aria-required": s,
          "data-state": Li(y),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: u,
          ...f,
          ref: w,
          onKeyDown: L(e.onKeyDown, (b) => {
            b.key === "Enter" && b.preventDefault();
          }),
          onClick: L(e.onClick, (b) => {
            E((S) => je(S) ? !0 : !S), g && (h.current = b.isPropagationStopped(), h.current || b.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ m(
        $i,
        {
          control: p,
          bubbles: !h.current,
          name: r,
          value: u,
          checked: y,
          required: s,
          disabled: a,
          form: d,
          style: { transform: "translateX(-100%)" },
          defaultChecked: je(i) ? !1 : i
        }
      )
    ] });
  }
);
Ii.displayName = En;
var _i = "CheckboxIndicator", ki = c.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, i = iu(_i, n);
    return /* @__PURE__ */ m(nt, { present: r || je(i.state) || i.state === !0, children: /* @__PURE__ */ m(
      re.span,
      {
        "data-state": Li(i.state),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
ki.displayName = _i;
var au = "CheckboxBubbleInput", $i = c.forwardRef(
  ({
    __scopeCheckbox: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    defaultChecked: o,
    ...i
  }, s) => {
    const a = c.useRef(null), u = Q(a, s), l = Kl(n), d = Oi(t);
    c.useEffect(() => {
      const p = a.current;
      if (!p)
        return;
      const v = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        v,
        "checked"
      ).set;
      if (l !== n && h) {
        const g = new Event("click", { bubbles: r });
        p.indeterminate = je(n), h.call(p, je(n) ? !1 : n), p.dispatchEvent(g);
      }
    }, [l, n, r]);
    const f = c.useRef(je(n) ? !1 : n);
    return /* @__PURE__ */ m(
      re.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: o ?? f.current,
        ...i,
        tabIndex: -1,
        ref: u,
        style: {
          ...i.style,
          ...d,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
$i.displayName = au;
function je(e) {
  return e === "indeterminate";
}
function Li(e) {
  return je(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var su = Ii, cu = ki;
// @__NO_SIDE_EFFECTS__
function No(e) {
  const t = /* @__PURE__ */ lu(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(du);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ m(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ m(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function lu(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = pu(o), a = fu(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? tt(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var uu = Symbol("radix.slottable");
function du(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === uu;
}
function fu(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function pu(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Fi(e) {
  const t = e + "CollectionProvider", [n, r] = Xe(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: g, children: y } = h, E = T.useRef(null), x = T.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ m(o, { scope: g, itemMap: x, collectionRef: E, children: y });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", u = /* @__PURE__ */ No(a), l = T.forwardRef(
    (h, g) => {
      const { scope: y, children: E } = h, x = i(a, y), b = Q(g, x.collectionRef);
      return /* @__PURE__ */ m(u, { ref: b, children: E });
    }
  );
  l.displayName = a;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", p = /* @__PURE__ */ No(d), v = T.forwardRef(
    (h, g) => {
      const { scope: y, children: E, ...x } = h, b = T.useRef(null), S = Q(g, b), N = i(d, y);
      return T.useEffect(() => (N.itemMap.set(b, { ref: b, ...x }), () => void N.itemMap.delete(b))), /* @__PURE__ */ m(p, { [f]: "", ref: S, children: E });
    }
  );
  v.displayName = d;
  function w(h) {
    const g = i(e + "CollectionConsumer", h);
    return T.useCallback(() => {
      const E = g.collectionRef.current;
      if (!E)
        return [];
      const x = Array.from(E.querySelectorAll(`[${f}]`));
      return Array.from(g.itemMap.values()).sort(
        (N, C) => x.indexOf(N.ref.current) - x.indexOf(C.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: s, Slot: l, ItemSlot: v },
    w,
    r
  ];
}
var mu = c.createContext(void 0);
function Bi(e) {
  const t = c.useContext(mu);
  return e || t || "ltr";
}
function se(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Wi(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e);
  c.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var hu = "DismissableLayer", lr = "dismissableLayer.update", gu = "dismissableLayer.pointerDownOutside", vu = "dismissableLayer.focusOutside", Po, Vi = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ui = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...u
    } = e, l = c.useContext(Vi), [d, f] = c.useState(null), p = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = c.useState({}), w = Q(t, (C) => f(C)), h = Array.from(l.layers), [g] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = h.indexOf(g), E = d ? h.indexOf(d) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, b = E >= y, S = wu((C) => {
      const R = C.target, O = [...l.branches].some((I) => I.contains(R));
      !b || O || (o == null || o(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, p), N = xu((C) => {
      const R = C.target;
      [...l.branches].some((I) => I.contains(R)) || (i == null || i(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, p);
    return Wi((C) => {
      E === l.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && a && (C.preventDefault(), a()));
    }, p), c.useEffect(() => {
      if (d)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Po = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), Ao(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = Po);
        };
    }, [d, p, n, l]), c.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), Ao());
    }, [d, l]), c.useEffect(() => {
      const C = () => v({});
      return document.addEventListener(lr, C), () => document.removeEventListener(lr, C);
    }, []), /* @__PURE__ */ m(
      re.div,
      {
        ...u,
        ref: w,
        style: {
          pointerEvents: x ? b ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: L(e.onFocusCapture, N.onFocusCapture),
        onBlurCapture: L(e.onBlurCapture, N.onBlurCapture),
        onPointerDownCapture: L(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
Ui.displayName = hu;
var yu = "DismissableLayerBranch", bu = c.forwardRef((e, t) => {
  const n = c.useContext(Vi), r = c.useRef(null), o = Q(t, r);
  return c.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ m(re.div, { ...e, ref: o });
});
bu.displayName = yu;
function wu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let u = function() {
          zi(
            gu,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function xu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && zi(vu, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Ao() {
  const e = new CustomEvent(lr);
  document.dispatchEvent(e);
}
function zi(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Di(o, i) : o.dispatchEvent(i);
}
var kn = 0;
function Eu() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Mo()), document.body.insertAdjacentElement("beforeend", e[1] ?? Mo()), kn++, () => {
      kn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), kn--;
    };
  }, []);
}
function Mo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var $n = "focusScope.autoFocusOnMount", Ln = "focusScope.autoFocusOnUnmount", Oo = { bubbles: !1, cancelable: !0 }, Cu = "FocusScope", Hi = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, u] = c.useState(null), l = se(o), d = se(i), f = c.useRef(null), p = Q(t, (h) => u(h)), v = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let h = function(x) {
        if (v.paused || !a)
          return;
        const b = x.target;
        a.contains(b) ? f.current = b : ze(f.current, { select: !0 });
      }, g = function(x) {
        if (v.paused || !a)
          return;
        const b = x.relatedTarget;
        b !== null && (a.contains(b) || ze(f.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && ze(a);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", g);
      const E = new MutationObserver(y);
      return a && E.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", g), E.disconnect();
      };
    }
  }, [r, a, v.paused]), c.useEffect(() => {
    if (a) {
      Io.add(v);
      const h = document.activeElement;
      if (!a.contains(h)) {
        const y = new CustomEvent($n, Oo);
        a.addEventListener($n, l), a.dispatchEvent(y), y.defaultPrevented || (Su(Au(ji(a)), { select: !0 }), document.activeElement === h && ze(a));
      }
      return () => {
        a.removeEventListener($n, l), setTimeout(() => {
          const y = new CustomEvent(Ln, Oo);
          a.addEventListener(Ln, d), a.dispatchEvent(y), y.defaultPrevented || ze(h ?? document.body, { select: !0 }), a.removeEventListener(Ln, d), Io.remove(v);
        }, 0);
      };
    }
  }, [a, l, d, v]);
  const w = c.useCallback(
    (h) => {
      if (!n && !r || v.paused)
        return;
      const g = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, y = document.activeElement;
      if (g && y) {
        const E = h.currentTarget, [x, b] = Ru(E);
        x && b ? !h.shiftKey && y === b ? (h.preventDefault(), n && ze(x, { select: !0 })) : h.shiftKey && y === x && (h.preventDefault(), n && ze(b, { select: !0 })) : y === E && h.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ m(re.div, { tabIndex: -1, ...s, ref: p, onKeyDown: w });
});
Hi.displayName = Cu;
function Su(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ze(r, { select: t }), document.activeElement !== n)
      return;
}
function Ru(e) {
  const t = ji(e), n = Do(t, e), r = Do(t.reverse(), e);
  return [n, r];
}
function ji(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Do(e, t) {
  for (const n of e)
    if (!Tu(n, { upTo: t }))
      return n;
}
function Tu(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Nu(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ze(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Nu(e) && t && e.select();
  }
}
var Io = Pu();
function Pu() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = _o(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = _o(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function _o(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Au(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Mu = c[" useId ".trim().toString()] || (() => {
}), Ou = 0;
function It(e) {
  const [t, n] = c.useState(Mu());
  return Te(() => {
    e || n((r) => r ?? String(Ou++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const Du = ["top", "right", "bottom", "left"], Ke = Math.min, pe = Math.max, pn = Math.round, Qt = Math.floor, Re = (e) => ({
  x: e,
  y: e
}), Iu = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, _u = {
  start: "end",
  end: "start"
};
function ur(e, t, n) {
  return pe(e, Ke(t, n));
}
function ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function $e(e) {
  return e.split("-")[0];
}
function gt(e) {
  return e.split("-")[1];
}
function Fr(e) {
  return e === "x" ? "y" : "x";
}
function Br(e) {
  return e === "y" ? "height" : "width";
}
function Ge(e) {
  return ["top", "bottom"].includes($e(e)) ? "y" : "x";
}
function Wr(e) {
  return Fr(Ge(e));
}
function ku(e, t, n) {
  n === void 0 && (n = !1);
  const r = gt(e), o = Wr(e), i = Br(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = mn(s)), [s, mn(s)];
}
function $u(e) {
  const t = mn(e);
  return [dr(e), t, dr(t)];
}
function dr(e) {
  return e.replace(/start|end/g, (t) => _u[t]);
}
function Lu(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function Fu(e, t, n, r) {
  const o = gt(e);
  let i = Lu($e(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(dr)))), i;
}
function mn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Iu[t]);
}
function Bu(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Ki(e) {
  return typeof e != "number" ? Bu(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function hn(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function ko(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Ge(t), s = Wr(t), a = Br(s), u = $e(t), l = i === "y", d = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, p = r[a] / 2 - o[a] / 2;
  let v;
  switch (u) {
    case "top":
      v = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      v = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      v = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      v = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      v = {
        x: r.x,
        y: r.y
      };
  }
  switch (gt(t)) {
    case "start":
      v[s] -= p * (n && l ? -1 : 1);
      break;
    case "end":
      v[s] += p * (n && l ? -1 : 1);
      break;
  }
  return v;
}
const Wu = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), u = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let l = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: f
  } = ko(l, r, u), p = r, v = {}, w = 0;
  for (let h = 0; h < a.length; h++) {
    const {
      name: g,
      fn: y
    } = a[h], {
      x: E,
      y: x,
      data: b,
      reset: S
    } = await y({
      x: d,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: v,
      rects: l,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = E ?? d, f = x ?? f, v = {
      ...v,
      [g]: {
        ...v[g],
        ...b
      }
    }, S && w <= 50 && (w++, typeof S == "object" && (S.placement && (p = S.placement), S.rects && (l = S.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: d,
      y: f
    } = ko(l, p, u)), h = -1);
  }
  return {
    x: d,
    y: f,
    placement: p,
    strategy: o,
    middlewareData: v
  };
};
async function _t(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: u
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: v = 0
  } = ke(t, e), w = Ki(v), g = a[p ? f === "floating" ? "reference" : "floating" : f], y = hn(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(g))) == null || n ? g : g.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: u
  })), E = f === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), b = await (i.isElement == null ? void 0 : i.isElement(x)) ? await (i.getScale == null ? void 0 : i.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = hn(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: E,
    offsetParent: x,
    strategy: u
  }) : E);
  return {
    top: (y.top - S.top + w.top) / b.y,
    bottom: (S.bottom - y.bottom + w.bottom) / b.y,
    left: (y.left - S.left + w.left) / b.x,
    right: (S.right - y.right + w.right) / b.x
  };
}
const Vu = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: u
    } = t, {
      element: l,
      padding: d = 0
    } = ke(e, t) || {};
    if (l == null)
      return {};
    const f = Ki(d), p = {
      x: n,
      y: r
    }, v = Wr(o), w = Br(v), h = await s.getDimensions(l), g = v === "y", y = g ? "top" : "left", E = g ? "bottom" : "right", x = g ? "clientHeight" : "clientWidth", b = i.reference[w] + i.reference[v] - p[v] - i.floating[w], S = p[v] - i.reference[v], N = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let C = N ? N[x] : 0;
    (!C || !await (s.isElement == null ? void 0 : s.isElement(N))) && (C = a.floating[x] || i.floating[w]);
    const R = b / 2 - S / 2, O = C / 2 - h[w] / 2 - 1, I = Ke(f[y], O), $ = Ke(f[E], O), D = I, A = C - h[w] - $, P = C / 2 - h[w] / 2 + R, F = ur(D, P, A), k = !u.arrow && gt(o) != null && P !== F && i.reference[w] / 2 - (P < D ? I : $) - h[w] / 2 < 0, V = k ? P < D ? P - D : P - A : 0;
    return {
      [v]: p[v] + V,
      data: {
        [v]: F,
        centerOffset: P - F - V,
        ...k && {
          alignmentOffset: V
        }
      },
      reset: k
    };
  }
}), Uu = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: u,
        elements: l
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: h = !0,
        ...g
      } = ke(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const y = $e(o), E = Ge(a), x = $e(a) === a, b = await (u.isRTL == null ? void 0 : u.isRTL(l.floating)), S = p || (x || !h ? [mn(a)] : $u(a)), N = w !== "none";
      !p && N && S.push(...Fu(a, h, w, b));
      const C = [a, ...S], R = await _t(t, g), O = [];
      let I = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && O.push(R[y]), f) {
        const P = ku(o, s, b);
        O.push(R[P[0]], R[P[1]]);
      }
      if (I = [...I, {
        placement: o,
        overflows: O
      }], !O.every((P) => P <= 0)) {
        var $, D;
        const P = ((($ = i.flip) == null ? void 0 : $.index) || 0) + 1, F = C[P];
        if (F)
          return {
            data: {
              index: P,
              overflows: I
            },
            reset: {
              placement: F
            }
          };
        let k = (D = I.filter((V) => V.overflows[0] <= 0).sort((V, _) => V.overflows[1] - _.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!k)
          switch (v) {
            case "bestFit": {
              var A;
              const V = (A = I.filter((_) => {
                if (N) {
                  const M = Ge(_.placement);
                  return M === E || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  M === "y";
                }
                return !0;
              }).map((_) => [_.placement, _.overflows.filter((M) => M > 0).reduce((M, j) => M + j, 0)]).sort((_, M) => _[1] - M[1])[0]) == null ? void 0 : A[0];
              V && (k = V);
              break;
            }
            case "initialPlacement":
              k = a;
              break;
          }
        if (o !== k)
          return {
            reset: {
              placement: k
            }
          };
      }
      return {};
    }
  };
};
function $o(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Lo(e) {
  return Du.some((t) => e[t] >= 0);
}
const zu = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = ke(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await _t(t, {
            ...o,
            elementContext: "reference"
          }), s = $o(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Lo(s)
            }
          };
        }
        case "escaped": {
          const i = await _t(t, {
            ...o,
            altBoundary: !0
          }), s = $o(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Lo(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Hu(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = $e(n), a = gt(n), u = Ge(n) === "y", l = ["left", "top"].includes(s) ? -1 : 1, d = i && u ? -1 : 1, f = ke(t, e);
  let {
    mainAxis: p,
    crossAxis: v,
    alignmentAxis: w
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof w == "number" && (v = a === "end" ? w * -1 : w), u ? {
    x: v * d,
    y: p * l
  } : {
    x: p * l,
    y: v * d
  };
}
const ju = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, u = await Hu(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + u.x,
        y: i + u.y,
        data: {
          ...u,
          placement: s
        }
      };
    }
  };
}, Ku = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (g) => {
            let {
              x: y,
              y: E
            } = g;
            return {
              x: y,
              y: E
            };
          }
        },
        ...u
      } = ke(e, t), l = {
        x: n,
        y: r
      }, d = await _t(t, u), f = Ge($e(o)), p = Fr(f);
      let v = l[p], w = l[f];
      if (i) {
        const g = p === "y" ? "top" : "left", y = p === "y" ? "bottom" : "right", E = v + d[g], x = v - d[y];
        v = ur(E, v, x);
      }
      if (s) {
        const g = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", E = w + d[g], x = w - d[y];
        w = ur(E, w, x);
      }
      const h = a.fn({
        ...t,
        [p]: v,
        [f]: w
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - r,
          enabled: {
            [p]: i,
            [f]: s
          }
        }
      };
    }
  };
}, Gu = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: u = !0,
        crossAxis: l = !0
      } = ke(e, t), d = {
        x: n,
        y: r
      }, f = Ge(o), p = Fr(f);
      let v = d[p], w = d[f];
      const h = ke(a, t), g = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (u) {
        const x = p === "y" ? "height" : "width", b = i.reference[p] - i.floating[x] + g.mainAxis, S = i.reference[p] + i.reference[x] - g.mainAxis;
        v < b ? v = b : v > S && (v = S);
      }
      if (l) {
        var y, E;
        const x = p === "y" ? "width" : "height", b = ["top", "left"].includes($e(o)), S = i.reference[f] - i.floating[x] + (b && ((y = s.offset) == null ? void 0 : y[f]) || 0) + (b ? 0 : g.crossAxis), N = i.reference[f] + i.reference[x] + (b ? 0 : ((E = s.offset) == null ? void 0 : E[f]) || 0) - (b ? g.crossAxis : 0);
        w < S ? w = S : w > N && (w = N);
      }
      return {
        [p]: v,
        [f]: w
      };
    }
  };
}, Yu = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: a
      } = t, {
        apply: u = () => {
        },
        ...l
      } = ke(e, t), d = await _t(t, l), f = $e(o), p = gt(o), v = Ge(o) === "y", {
        width: w,
        height: h
      } = i.floating;
      let g, y;
      f === "top" || f === "bottom" ? (g = f, y = p === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (y = f, g = p === "end" ? "top" : "bottom");
      const E = h - d.top - d.bottom, x = w - d.left - d.right, b = Ke(h - d[g], E), S = Ke(w - d[y], x), N = !t.middlewareData.shift;
      let C = b, R = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (R = x), (r = t.middlewareData.shift) != null && r.enabled.y && (C = E), N && !p) {
        const I = pe(d.left, 0), $ = pe(d.right, 0), D = pe(d.top, 0), A = pe(d.bottom, 0);
        v ? R = w - 2 * (I !== 0 || $ !== 0 ? I + $ : pe(d.left, d.right)) : C = h - 2 * (D !== 0 || A !== 0 ? D + A : pe(d.top, d.bottom));
      }
      await u({
        ...t,
        availableWidth: R,
        availableHeight: C
      });
      const O = await s.getDimensions(a.floating);
      return w !== O.width || h !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Cn() {
  return typeof window < "u";
}
function vt(e) {
  return Gi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function me(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ae(e) {
  var t;
  return (t = (Gi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Gi(e) {
  return Cn() ? e instanceof Node || e instanceof me(e).Node : !1;
}
function we(e) {
  return Cn() ? e instanceof Element || e instanceof me(e).Element : !1;
}
function Ne(e) {
  return Cn() ? e instanceof HTMLElement || e instanceof me(e).HTMLElement : !1;
}
function Fo(e) {
  return !Cn() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof me(e).ShadowRoot;
}
function Wt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Xu(e) {
  return ["table", "td", "th"].includes(vt(e));
}
function Sn(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Vr(e) {
  const t = Ur(), n = we(e) ? xe(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function qu(e) {
  let t = Ye(e);
  for (; Ne(t) && !mt(t); ) {
    if (Vr(t))
      return t;
    if (Sn(t))
      return null;
    t = Ye(t);
  }
  return null;
}
function Ur() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function mt(e) {
  return ["html", "body", "#document"].includes(vt(e));
}
function xe(e) {
  return me(e).getComputedStyle(e);
}
function Rn(e) {
  return we(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ye(e) {
  if (vt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Fo(e) && e.host || // Fallback.
    Ae(e)
  );
  return Fo(t) ? t.host : t;
}
function Yi(e) {
  const t = Ye(e);
  return mt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ne(t) && Wt(t) ? t : Yi(t);
}
function kt(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Yi(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = me(o);
  if (i) {
    const a = fr(s);
    return t.concat(s, s.visualViewport || [], Wt(o) ? o : [], a && n ? kt(a) : []);
  }
  return t.concat(o, kt(o, [], n));
}
function fr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Xi(e) {
  const t = xe(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Ne(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = pn(n) !== i || pn(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function zr(e) {
  return we(e) ? e : e.contextElement;
}
function dt(e) {
  const t = zr(e);
  if (!Ne(t))
    return Re(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Xi(t);
  let s = (i ? pn(n.width) : n.width) / r, a = (i ? pn(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Zu = /* @__PURE__ */ Re(0);
function qi(e) {
  const t = me(e);
  return !Ur() || !t.visualViewport ? Zu : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Qu(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== me(e) ? !1 : t;
}
function Je(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = zr(e);
  let s = Re(1);
  t && (r ? we(r) && (s = dt(r)) : s = dt(e));
  const a = Qu(i, n, r) ? qi(i) : Re(0);
  let u = (o.left + a.x) / s.x, l = (o.top + a.y) / s.y, d = o.width / s.x, f = o.height / s.y;
  if (i) {
    const p = me(i), v = r && we(r) ? me(r) : r;
    let w = p, h = fr(w);
    for (; h && r && v !== w; ) {
      const g = dt(h), y = h.getBoundingClientRect(), E = xe(h), x = y.left + (h.clientLeft + parseFloat(E.paddingLeft)) * g.x, b = y.top + (h.clientTop + parseFloat(E.paddingTop)) * g.y;
      u *= g.x, l *= g.y, d *= g.x, f *= g.y, u += x, l += b, w = me(h), h = fr(w);
    }
  }
  return hn({
    width: d,
    height: f,
    x: u,
    y: l
  });
}
function Hr(e, t) {
  const n = Rn(e).scrollLeft;
  return t ? t.left + n : Je(Ae(e)).left + n;
}
function Zi(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Hr(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function Ju(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = Ae(r), a = t ? Sn(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Re(1);
  const d = Re(0), f = Ne(r);
  if ((f || !f && !i) && ((vt(r) !== "body" || Wt(s)) && (u = Rn(r)), Ne(r))) {
    const v = Je(r);
    l = dt(r), d.x = v.x + r.clientLeft, d.y = v.y + r.clientTop;
  }
  const p = s && !f && !i ? Zi(s, u, !0) : Re(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - u.scrollLeft * l.x + d.x + p.x,
    y: n.y * l.y - u.scrollTop * l.y + d.y + p.y
  };
}
function ed(e) {
  return Array.from(e.getClientRects());
}
function td(e) {
  const t = Ae(e), n = Rn(e), r = e.ownerDocument.body, o = pe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = pe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Hr(e);
  const a = -n.scrollTop;
  return xe(r).direction === "rtl" && (s += pe(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function nd(e, t) {
  const n = me(e), r = Ae(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, u = 0;
  if (o) {
    i = o.width, s = o.height;
    const l = Ur();
    (!l || l && t === "fixed") && (a = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: u
  };
}
function rd(e, t) {
  const n = Je(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Ne(e) ? dt(e) : Re(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, u = o * i.x, l = r * i.y;
  return {
    width: s,
    height: a,
    x: u,
    y: l
  };
}
function Bo(e, t, n) {
  let r;
  if (t === "viewport")
    r = nd(e, n);
  else if (t === "document")
    r = td(Ae(e));
  else if (we(t))
    r = rd(t, n);
  else {
    const o = qi(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return hn(r);
}
function Qi(e, t) {
  const n = Ye(e);
  return n === t || !we(n) || mt(n) ? !1 : xe(n).position === "fixed" || Qi(n, t);
}
function od(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = kt(e, [], !1).filter((a) => we(a) && vt(a) !== "body"), o = null;
  const i = xe(e).position === "fixed";
  let s = i ? Ye(e) : e;
  for (; we(s) && !mt(s); ) {
    const a = xe(s), u = Vr(s);
    !u && a.position === "fixed" && (o = null), (i ? !u && !o : !u && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Wt(s) && !u && Qi(e, s)) ? r = r.filter((d) => d !== s) : o = a, s = Ye(s);
  }
  return t.set(e, r), r;
}
function id(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Sn(t) ? [] : od(t, this._c) : [].concat(n), r], a = s[0], u = s.reduce((l, d) => {
    const f = Bo(t, d, o);
    return l.top = pe(f.top, l.top), l.right = Ke(f.right, l.right), l.bottom = Ke(f.bottom, l.bottom), l.left = pe(f.left, l.left), l;
  }, Bo(t, a, o));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function ad(e) {
  const {
    width: t,
    height: n
  } = Xi(e);
  return {
    width: t,
    height: n
  };
}
function sd(e, t, n) {
  const r = Ne(t), o = Ae(t), i = n === "fixed", s = Je(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = Re(0);
  if (r || !r && !i)
    if ((vt(t) !== "body" || Wt(o)) && (a = Rn(t)), r) {
      const p = Je(t, !0, i, t);
      u.x = p.x + t.clientLeft, u.y = p.y + t.clientTop;
    } else
      o && (u.x = Hr(o));
  const l = o && !r && !i ? Zi(o, a) : Re(0), d = s.left + a.scrollLeft - u.x - l.x, f = s.top + a.scrollTop - u.y - l.y;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Fn(e) {
  return xe(e).position === "static";
}
function Wo(e, t) {
  if (!Ne(e) || xe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ae(e) === n && (n = n.ownerDocument.body), n;
}
function Ji(e, t) {
  const n = me(e);
  if (Sn(e))
    return n;
  if (!Ne(e)) {
    let o = Ye(e);
    for (; o && !mt(o); ) {
      if (we(o) && !Fn(o))
        return o;
      o = Ye(o);
    }
    return n;
  }
  let r = Wo(e, t);
  for (; r && Xu(r) && Fn(r); )
    r = Wo(r, t);
  return r && mt(r) && Fn(r) && !Vr(r) ? n : r || qu(e) || n;
}
const cd = async function(e) {
  const t = this.getOffsetParent || Ji, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: sd(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function ld(e) {
  return xe(e).direction === "rtl";
}
const ud = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ju,
  getDocumentElement: Ae,
  getClippingRect: id,
  getOffsetParent: Ji,
  getElementRects: cd,
  getClientRects: ed,
  getDimensions: ad,
  getScale: dt,
  isElement: we,
  isRTL: ld
};
function ea(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function dd(e, t) {
  let n = null, r;
  const o = Ae(e);
  function i() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, u) {
    a === void 0 && (a = !1), u === void 0 && (u = 1), i();
    const l = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: p,
      height: v
    } = l;
    if (a || t(), !p || !v)
      return;
    const w = Qt(f), h = Qt(o.clientWidth - (d + p)), g = Qt(o.clientHeight - (f + v)), y = Qt(d), x = {
      rootMargin: -w + "px " + -h + "px " + -g + "px " + -y + "px",
      threshold: pe(0, Ke(1, u)) || 1
    };
    let b = !0;
    function S(N) {
      const C = N[0].intersectionRatio;
      if (C !== u) {
        if (!b)
          return s();
        C ? s(!1, C) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !ea(l, e.getBoundingClientRect()) && s(), b = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, x);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function fd(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, l = zr(e), d = o || i ? [...l ? kt(l) : [], ...kt(t)] : [];
  d.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const f = l && a ? dd(l, n) : null;
  let p = -1, v = null;
  s && (v = new ResizeObserver((y) => {
    let [E] = y;
    E && E.target === l && v && (v.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var x;
      (x = v) == null || x.observe(t);
    })), n();
  }), l && !u && v.observe(l), v.observe(t));
  let w, h = u ? Je(e) : null;
  u && g();
  function g() {
    const y = Je(e);
    h && !ea(h, y) && n(), h = y, w = requestAnimationFrame(g);
  }
  return n(), () => {
    var y;
    d.forEach((E) => {
      o && E.removeEventListener("scroll", n), i && E.removeEventListener("resize", n);
    }), f == null || f(), (y = v) == null || y.disconnect(), v = null, u && cancelAnimationFrame(w);
  };
}
const pd = ju, md = Ku, hd = Uu, gd = Yu, vd = zu, Vo = Vu, yd = Gu, bd = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: ud,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return Wu(e, t, {
    ...o,
    platform: i
  });
};
var ln = typeof document < "u" ? yi : be;
function gn(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!gn(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !gn(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function ta(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Uo(e, t) {
  const n = ta(e);
  return Math.round(t * n) / n;
}
function Bn(e) {
  const t = c.useRef(e);
  return ln(() => {
    t.current = e;
  }), t;
}
function wd(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: u,
    open: l
  } = e, [d, f] = c.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, v] = c.useState(r);
  gn(p, r) || v(r);
  const [w, h] = c.useState(null), [g, y] = c.useState(null), E = c.useCallback((_) => {
    _ !== N.current && (N.current = _, h(_));
  }, []), x = c.useCallback((_) => {
    _ !== C.current && (C.current = _, y(_));
  }, []), b = i || w, S = s || g, N = c.useRef(null), C = c.useRef(null), R = c.useRef(d), O = u != null, I = Bn(u), $ = Bn(o), D = Bn(l), A = c.useCallback(() => {
    if (!N.current || !C.current)
      return;
    const _ = {
      placement: t,
      strategy: n,
      middleware: p
    };
    $.current && (_.platform = $.current), bd(N.current, C.current, _).then((M) => {
      const j = {
        ...M,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: D.current !== !1
      };
      P.current && !gn(R.current, j) && (R.current = j, Ft.flushSync(() => {
        f(j);
      }));
    });
  }, [p, t, n, $, D]);
  ln(() => {
    l === !1 && R.current.isPositioned && (R.current.isPositioned = !1, f((_) => ({
      ..._,
      isPositioned: !1
    })));
  }, [l]);
  const P = c.useRef(!1);
  ln(() => (P.current = !0, () => {
    P.current = !1;
  }), []), ln(() => {
    if (b && (N.current = b), S && (C.current = S), b && S) {
      if (I.current)
        return I.current(b, S, A);
      A();
    }
  }, [b, S, A, I, O]);
  const F = c.useMemo(() => ({
    reference: N,
    floating: C,
    setReference: E,
    setFloating: x
  }), [E, x]), k = c.useMemo(() => ({
    reference: b,
    floating: S
  }), [b, S]), V = c.useMemo(() => {
    const _ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!k.floating)
      return _;
    const M = Uo(k.floating, d.x), j = Uo(k.floating, d.y);
    return a ? {
      ..._,
      transform: "translate(" + M + "px, " + j + "px)",
      ...ta(k.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: j
    };
  }, [n, a, k.floating, d.x, d.y]);
  return c.useMemo(() => ({
    ...d,
    update: A,
    refs: F,
    elements: k,
    floatingStyles: V
  }), [d, A, F, k, V]);
}
const xd = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Vo({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Vo({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Ed = (e, t) => ({
  ...pd(e),
  options: [e, t]
}), Cd = (e, t) => ({
  ...md(e),
  options: [e, t]
}), Sd = (e, t) => ({
  ...yd(e),
  options: [e, t]
}), Rd = (e, t) => ({
  ...hd(e),
  options: [e, t]
}), Td = (e, t) => ({
  ...gd(e),
  options: [e, t]
}), Nd = (e, t) => ({
  ...vd(e),
  options: [e, t]
}), Pd = (e, t) => ({
  ...xd(e),
  options: [e, t]
});
var Ad = "Arrow", na = c.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ m(
    re.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ m("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
na.displayName = Ad;
var Md = na, jr = "Popper", [ra, oa] = Xe(jr), [Od, ia] = ra(jr), aa = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = c.useState(null);
  return /* @__PURE__ */ m(Od, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
aa.displayName = jr;
var sa = "PopperAnchor", ca = c.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = ia(sa, n), s = c.useRef(null), a = Q(t, s);
    return c.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ m(re.div, { ...o, ref: a });
  }
);
ca.displayName = sa;
var Kr = "PopperContent", [Dd, Id] = ra(Kr), la = c.forwardRef(
  (e, t) => {
    var le, ve, ae, Oe, De, wt;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: u = !0,
      collisionBoundary: l = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: v = "optimized",
      onPlaced: w,
      ...h
    } = e, g = ia(Kr, n), [y, E] = c.useState(null), x = Q(t, (Fe) => E(Fe)), [b, S] = c.useState(null), N = Oi(b), C = (N == null ? void 0 : N.width) ?? 0, R = (N == null ? void 0 : N.height) ?? 0, O = r + (i !== "center" ? "-" + i : ""), I = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, $ = Array.isArray(l) ? l : [l], D = $.length > 0, A = {
      padding: I,
      boundary: $.filter(kd),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: D
    }, { refs: P, floatingStyles: F, placement: k, isPositioned: V, middlewareData: _ } = wd({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: O,
      whileElementsMounted: (...Fe) => fd(...Fe, {
        animationFrame: v === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        Ed({ mainAxis: o + R, alignmentAxis: s }),
        u && Cd({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Sd() : void 0,
          ...A
        }),
        u && Rd({ ...A }),
        Td({
          ...A,
          apply: ({ elements: Fe, rects: U, availableWidth: Gt, availableHeight: Yt }) => {
            const { width: xt, height: In } = U.reference, ot = Fe.floating.style;
            ot.setProperty("--radix-popper-available-width", `${Gt}px`), ot.setProperty("--radix-popper-available-height", `${Yt}px`), ot.setProperty("--radix-popper-anchor-width", `${xt}px`), ot.setProperty("--radix-popper-anchor-height", `${In}px`);
          }
        }),
        b && Pd({ element: b, padding: a }),
        $d({ arrowWidth: C, arrowHeight: R }),
        p && Nd({ strategy: "referenceHidden", ...A })
      ]
    }), [M, j] = fa(k), G = se(w);
    Te(() => {
      V && (G == null || G());
    }, [V, G]);
    const oe = (le = _.arrow) == null ? void 0 : le.x, ie = (ve = _.arrow) == null ? void 0 : ve.y, fe = ((ae = _.arrow) == null ? void 0 : ae.centerOffset) !== 0, [Le, ge] = c.useState();
    return Te(() => {
      y && ge(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ m(
      "div",
      {
        ref: P.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...F,
          transform: V ? F.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Le,
          "--radix-popper-transform-origin": [
            (Oe = _.transformOrigin) == null ? void 0 : Oe.x,
            (De = _.transformOrigin) == null ? void 0 : De.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((wt = _.hide) == null ? void 0 : wt.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ m(
          Dd,
          {
            scope: n,
            placedSide: M,
            onArrowChange: S,
            arrowX: oe,
            arrowY: ie,
            shouldHideArrow: fe,
            children: /* @__PURE__ */ m(
              re.div,
              {
                "data-side": M,
                "data-align": j,
                ...h,
                ref: x,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
la.displayName = Kr;
var ua = "PopperArrow", _d = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, da = c.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = Id(ua, r), s = _d[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ m(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ m(
          Md,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
da.displayName = ua;
function kd(e) {
  return e !== null;
}
var $d = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var g, y, E;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((g = o.arrow) == null ? void 0 : g.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, u = s ? 0 : e.arrowHeight, [l, d] = fa(n), f = { start: "0%", center: "50%", end: "100%" }[d], p = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + a / 2, v = (((E = o.arrow) == null ? void 0 : E.y) ?? 0) + u / 2;
    let w = "", h = "";
    return l === "bottom" ? (w = s ? f : `${p}px`, h = `${-u}px`) : l === "top" ? (w = s ? f : `${p}px`, h = `${r.floating.height + u}px`) : l === "right" ? (w = `${-u}px`, h = s ? f : `${v}px`) : l === "left" && (w = `${r.floating.width + u}px`, h = s ? f : `${v}px`), { data: { x: w, y: h } };
  }
});
function fa(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var pa = aa, Ld = ca, Fd = la, Bd = da, Wd = "Portal", ma = c.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = c.useState(!1);
  Te(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? kr.createPortal(/* @__PURE__ */ m(re.div, { ...r, ref: t }), s) : null;
});
ma.displayName = Wd;
var Wn = "rovingFocusGroup.onEntryFocus", Vd = { bubbles: !1, cancelable: !0 }, Vt = "RovingFocusGroup", [pr, ha, Ud] = Fi(Vt), [zd, ga] = Xe(
  Vt,
  [Ud]
), [Hd, jd] = zd(Vt), va = c.forwardRef(
  (e, t) => /* @__PURE__ */ m(pr.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(pr.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(Kd, { ...e, ref: t }) }) })
);
va.displayName = Vt;
var Kd = c.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: u,
    onEntryFocus: l,
    preventScrollOnEntryFocus: d = !1,
    ...f
  } = e, p = c.useRef(null), v = Q(t, p), w = Bi(i), [h, g] = Bt({
    prop: s,
    defaultProp: a ?? null,
    onChange: u,
    caller: Vt
  }), [y, E] = c.useState(!1), x = se(l), b = ha(n), S = c.useRef(!1), [N, C] = c.useState(0);
  return c.useEffect(() => {
    const R = p.current;
    if (R)
      return R.addEventListener(Wn, x), () => R.removeEventListener(Wn, x);
  }, [x]), /* @__PURE__ */ m(
    Hd,
    {
      scope: n,
      orientation: r,
      dir: w,
      loop: o,
      currentTabStopId: h,
      onItemFocus: c.useCallback(
        (R) => g(R),
        [g]
      ),
      onItemShiftTab: c.useCallback(() => E(!0), []),
      onFocusableItemAdd: c.useCallback(
        () => C((R) => R + 1),
        []
      ),
      onFocusableItemRemove: c.useCallback(
        () => C((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ m(
        re.div,
        {
          tabIndex: y || N === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: v,
          style: { outline: "none", ...e.style },
          onMouseDown: L(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: L(e.onFocus, (R) => {
            const O = !S.current;
            if (R.target === R.currentTarget && O && !y) {
              const I = new CustomEvent(Wn, Vd);
              if (R.currentTarget.dispatchEvent(I), !I.defaultPrevented) {
                const $ = b().filter((k) => k.focusable), D = $.find((k) => k.active), A = $.find((k) => k.id === h), F = [D, A, ...$].filter(
                  Boolean
                ).map((k) => k.ref.current);
                wa(F, d);
              }
            }
            S.current = !1;
          }),
          onBlur: L(e.onBlur, () => E(!1))
        }
      )
    }
  );
}), ya = "RovingFocusGroupItem", ba = c.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      children: s,
      ...a
    } = e, u = It(), l = i || u, d = jd(ya, n), f = d.currentTabStopId === l, p = ha(n), { onFocusableItemAdd: v, onFocusableItemRemove: w, currentTabStopId: h } = d;
    return c.useEffect(() => {
      if (r)
        return v(), () => w();
    }, [r, v, w]), /* @__PURE__ */ m(
      pr.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ m(
          re.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": d.orientation,
            ...a,
            ref: t,
            onMouseDown: L(e.onMouseDown, (g) => {
              r ? d.onItemFocus(l) : g.preventDefault();
            }),
            onFocus: L(e.onFocus, () => d.onItemFocus(l)),
            onKeyDown: L(e.onKeyDown, (g) => {
              if (g.key === "Tab" && g.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (g.target !== g.currentTarget)
                return;
              const y = Xd(g, d.orientation, d.dir);
              if (y !== void 0) {
                if (g.metaKey || g.ctrlKey || g.altKey || g.shiftKey)
                  return;
                g.preventDefault();
                let x = p().filter((b) => b.focusable).map((b) => b.ref.current);
                if (y === "last")
                  x.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && x.reverse();
                  const b = x.indexOf(g.currentTarget);
                  x = d.loop ? qd(x, b + 1) : x.slice(b + 1);
                }
                setTimeout(() => wa(x));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: f, hasTabStop: h != null }) : s
          }
        )
      }
    );
  }
);
ba.displayName = ya;
var Gd = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Yd(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Xd(e, t, n) {
  const r = Yd(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Gd[r];
}
function wa(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function qd(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Zd = va, Qd = ba;
// @__NO_SIDE_EFFECTS__
function Jd(e) {
  const t = /* @__PURE__ */ ef(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(nf);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ m(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ m(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function ef(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = of(o), a = rf(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? tt(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var tf = Symbol("radix.slottable");
function nf(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === tf;
}
function rf(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function of(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var af = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, at = /* @__PURE__ */ new WeakMap(), Jt = /* @__PURE__ */ new WeakMap(), en = {}, Vn = 0, xa = function(e) {
  return e && (e.host || xa(e.parentNode));
}, sf = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = xa(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, cf = function(e, t, n, r) {
  var o = sf(t, Array.isArray(e) ? e : [e]);
  en[n] || (en[n] = /* @__PURE__ */ new WeakMap());
  var i = en[n], s = [], a = /* @__PURE__ */ new Set(), u = new Set(o), l = function(f) {
    !f || a.has(f) || (a.add(f), l(f.parentNode));
  };
  o.forEach(l);
  var d = function(f) {
    !f || u.has(f) || Array.prototype.forEach.call(f.children, function(p) {
      if (a.has(p))
        d(p);
      else
        try {
          var v = p.getAttribute(r), w = v !== null && v !== "false", h = (at.get(p) || 0) + 1, g = (i.get(p) || 0) + 1;
          at.set(p, h), i.set(p, g), s.push(p), h === 1 && w && Jt.set(p, !0), g === 1 && p.setAttribute(n, "true"), w || p.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", p, y);
        }
    });
  };
  return d(t), a.clear(), Vn++, function() {
    s.forEach(function(f) {
      var p = at.get(f) - 1, v = i.get(f) - 1;
      at.set(f, p), i.set(f, v), p || (Jt.has(f) || f.removeAttribute(r), Jt.delete(f)), v || f.removeAttribute(n);
    }), Vn--, Vn || (at = /* @__PURE__ */ new WeakMap(), at = /* @__PURE__ */ new WeakMap(), Jt = /* @__PURE__ */ new WeakMap(), en = {});
  };
}, Ea = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || af(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), cf(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Se = function() {
  return Se = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Se.apply(this, arguments);
};
function Ca(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function lf(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var un = "right-scroll-bar-position", dn = "width-before-scroll-bar", uf = "with-scroll-bars-hidden", df = "--removed-body-scroll-bar-size";
function Un(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function ff(e, t) {
  var n = Pe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var pf = typeof window < "u" ? c.useLayoutEffect : c.useEffect, zo = /* @__PURE__ */ new WeakMap();
function mf(e, t) {
  var n = ff(t || null, function(r) {
    return e.forEach(function(o) {
      return Un(o, r);
    });
  });
  return pf(function() {
    var r = zo.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(a) {
        i.has(a) || Un(a, null);
      }), i.forEach(function(a) {
        o.has(a) || Un(a, s);
      });
    }
    zo.set(n, e);
  }, [e]), n;
}
function hf(e) {
  return e;
}
function gf(e, t) {
  t === void 0 && (t = hf);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var u = function() {
        var d = s;
        s = [], d.forEach(i);
      }, l = function() {
        return Promise.resolve().then(u);
      };
      l(), n = {
        push: function(d) {
          s.push(d), l();
        },
        filter: function(d) {
          return s = s.filter(d), n;
        }
      };
    }
  };
  return o;
}
function vf(e) {
  e === void 0 && (e = {});
  var t = gf(null);
  return t.options = Se({ async: !0, ssr: !1 }, e), t;
}
var Sa = function(e) {
  var t = e.sideCar, n = Ca(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return c.createElement(r, Se({}, n));
};
Sa.isSideCarExport = !0;
function yf(e, t) {
  return e.useMedium(t), Sa;
}
var Ra = vf(), zn = function() {
}, Tn = c.forwardRef(function(e, t) {
  var n = c.useRef(null), r = c.useState({
    onScrollCapture: zn,
    onWheelCapture: zn,
    onTouchMoveCapture: zn
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, u = e.className, l = e.removeScrollBar, d = e.enabled, f = e.shards, p = e.sideCar, v = e.noIsolation, w = e.inert, h = e.allowPinchZoom, g = e.as, y = g === void 0 ? "div" : g, E = e.gapMode, x = Ca(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), b = p, S = mf([n, t]), N = Se(Se({}, x), o);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(b, { sideCar: Ra, removeScrollBar: l, shards: f, noIsolation: v, inert: w, setCallbacks: i, allowPinchZoom: !!h, lockRef: n, gapMode: E }),
    s ? c.cloneElement(c.Children.only(a), Se(Se({}, N), { ref: S })) : c.createElement(y, Se({}, N, { className: u, ref: S }), a)
  );
});
Tn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Tn.classNames = {
  fullWidth: dn,
  zeroRight: un
};
var Ho, bf = function() {
  if (Ho)
    return Ho;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function wf() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = bf();
  return t && e.setAttribute("nonce", t), e;
}
function xf(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Ef(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Cf = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = wf()) && (xf(t, n), Ef(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Sf = function() {
  var e = Cf();
  return function(t, n) {
    c.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Ta = function() {
  var e = Sf(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Rf = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Hn = function(e) {
  return parseInt(e || "", 10) || 0;
}, Tf = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Hn(n), Hn(r), Hn(o)];
}, Nf = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Rf;
  var t = Tf(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Pf = Ta(), ft = "data-scroll-locked", Af = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(uf, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(ft, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(un, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(dn, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(un, " .").concat(un, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(dn, " .").concat(dn, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(ft, `] {
    `).concat(df, ": ").concat(a, `px;
  }
`);
}, jo = function() {
  var e = parseInt(document.body.getAttribute(ft) || "0", 10);
  return isFinite(e) ? e : 0;
}, Mf = function() {
  c.useEffect(function() {
    return document.body.setAttribute(ft, (jo() + 1).toString()), function() {
      var e = jo() - 1;
      e <= 0 ? document.body.removeAttribute(ft) : document.body.setAttribute(ft, e.toString());
    };
  }, []);
}, Of = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Mf();
  var i = c.useMemo(function() {
    return Nf(o);
  }, [o]);
  return c.createElement(Pf, { styles: Af(i, !t, o, n ? "" : "!important") });
}, mr = !1;
if (typeof window < "u")
  try {
    var tn = Object.defineProperty({}, "passive", {
      get: function() {
        return mr = !0, !0;
      }
    });
    window.addEventListener("test", tn, tn), window.removeEventListener("test", tn, tn);
  } catch {
    mr = !1;
  }
var st = mr ? { passive: !1 } : !1, Df = function(e) {
  return e.tagName === "TEXTAREA";
}, Na = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Df(e) && n[t] === "visible")
  );
}, If = function(e) {
  return Na(e, "overflowY");
}, _f = function(e) {
  return Na(e, "overflowX");
}, Ko = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Pa(e, r);
    if (o) {
      var i = Aa(e, r), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, kf = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, $f = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Pa = function(e, t) {
  return e === "v" ? If(t) : _f(t);
}, Aa = function(e, t) {
  return e === "v" ? kf(t) : $f(t);
}, Lf = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Ff = function(e, t, n, r, o) {
  var i = Lf(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, u = t.contains(a), l = !1, d = s > 0, f = 0, p = 0;
  do {
    var v = Aa(e, a), w = v[0], h = v[1], g = v[2], y = h - g - i * w;
    (w || y) && Pa(e, a) && (f += y, p += w), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !u && a !== document.body || // self content
    u && (t.contains(a) || t === a)
  );
  return (d && (o && Math.abs(f) < 1 || !o && s > f) || !d && (o && Math.abs(p) < 1 || !o && -s > p)) && (l = !0), l;
}, nn = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Go = function(e) {
  return [e.deltaX, e.deltaY];
}, Yo = function(e) {
  return e && "current" in e ? e.current : e;
}, Bf = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Wf = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Vf = 0, ct = [];
function Uf(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), r = c.useRef(), o = c.useState(Vf++)[0], i = c.useState(Ta)[0], s = c.useRef(e);
  c.useEffect(function() {
    s.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = lf([e.lockRef.current], (e.shards || []).map(Yo), !0).filter(Boolean);
      return h.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = c.useCallback(function(h, g) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !s.current.allowPinchZoom;
    var y = nn(h), E = n.current, x = "deltaX" in h ? h.deltaX : E[0] - y[0], b = "deltaY" in h ? h.deltaY : E[1] - y[1], S, N = h.target, C = Math.abs(x) > Math.abs(b) ? "h" : "v";
    if ("touches" in h && C === "h" && N.type === "range")
      return !1;
    var R = Ko(C, N);
    if (!R)
      return !0;
    if (R ? S = C : (S = C === "v" ? "h" : "v", R = Ko(C, N)), !R)
      return !1;
    if (!r.current && "changedTouches" in h && (x || b) && (r.current = S), !S)
      return !0;
    var O = r.current || S;
    return Ff(O, g, h, O === "h" ? x : b, !0);
  }, []), u = c.useCallback(function(h) {
    var g = h;
    if (!(!ct.length || ct[ct.length - 1] !== i)) {
      var y = "deltaY" in g ? Go(g) : nn(g), E = t.current.filter(function(S) {
        return S.name === g.type && (S.target === g.target || g.target === S.shadowParent) && Bf(S.delta, y);
      })[0];
      if (E && E.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!E) {
        var x = (s.current.shards || []).map(Yo).filter(Boolean).filter(function(S) {
          return S.contains(g.target);
        }), b = x.length > 0 ? a(g, x[0]) : !s.current.noIsolation;
        b && g.cancelable && g.preventDefault();
      }
    }
  }, []), l = c.useCallback(function(h, g, y, E) {
    var x = { name: h, delta: g, target: y, should: E, shadowParent: zf(y) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(b) {
        return b !== x;
      });
    }, 1);
  }, []), d = c.useCallback(function(h) {
    n.current = nn(h), r.current = void 0;
  }, []), f = c.useCallback(function(h) {
    l(h.type, Go(h), h.target, a(h, e.lockRef.current));
  }, []), p = c.useCallback(function(h) {
    l(h.type, nn(h), h.target, a(h, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return ct.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", u, st), document.addEventListener("touchmove", u, st), document.addEventListener("touchstart", d, st), function() {
      ct = ct.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", u, st), document.removeEventListener("touchmove", u, st), document.removeEventListener("touchstart", d, st);
    };
  }, []);
  var v = e.removeScrollBar, w = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    w ? c.createElement(i, { styles: Wf(o) }) : null,
    v ? c.createElement(Of, { gapMode: e.gapMode }) : null
  );
}
function zf(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Hf = yf(Ra, Uf);
var Ma = c.forwardRef(function(e, t) {
  return c.createElement(Tn, Se({}, e, { ref: t, sideCar: Hf }));
});
Ma.classNames = Tn.classNames;
const Oa = Ma;
var hr = ["Enter", " "], jf = ["ArrowDown", "PageUp", "Home"], Da = ["ArrowUp", "PageDown", "End"], Kf = [...jf, ...Da], Gf = {
  ltr: [...hr, "ArrowRight"],
  rtl: [...hr, "ArrowLeft"]
}, Yf = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Ut = "Menu", [$t, Xf, qf] = Fi(Ut), [rt, Ia] = Xe(Ut, [
  qf,
  oa,
  ga
]), zt = oa(), _a = ga(), [ka, qe] = rt(Ut), [Zf, Ht] = rt(Ut), $a = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: s = !0 } = e, a = zt(t), [u, l] = c.useState(null), d = c.useRef(!1), f = se(i), p = Bi(o);
  return c.useEffect(() => {
    const v = () => {
      d.current = !0, document.addEventListener("pointerdown", w, { capture: !0, once: !0 }), document.addEventListener("pointermove", w, { capture: !0, once: !0 });
    }, w = () => d.current = !1;
    return document.addEventListener("keydown", v, { capture: !0 }), () => {
      document.removeEventListener("keydown", v, { capture: !0 }), document.removeEventListener("pointerdown", w, { capture: !0 }), document.removeEventListener("pointermove", w, { capture: !0 });
    };
  }, []), /* @__PURE__ */ m(pa, { ...a, children: /* @__PURE__ */ m(
    ka,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: u,
      onContentChange: l,
      children: /* @__PURE__ */ m(
        Zf,
        {
          scope: t,
          onClose: c.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: d,
          dir: p,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
$a.displayName = Ut;
var Qf = "MenuAnchor", Gr = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = zt(n);
    return /* @__PURE__ */ m(Ld, { ...o, ...r, ref: t });
  }
);
Gr.displayName = Qf;
var Yr = "MenuPortal", [Jf, La] = rt(Yr, {
  forceMount: void 0
}), Fa = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = qe(Yr, t);
  return /* @__PURE__ */ m(Jf, { scope: t, forceMount: n, children: /* @__PURE__ */ m(nt, { present: n || i.open, children: /* @__PURE__ */ m(ma, { asChild: !0, container: o, children: r }) }) });
};
Fa.displayName = Yr;
var he = "MenuContent", [ep, Xr] = rt(he), Ba = c.forwardRef(
  (e, t) => {
    const n = La(he, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = qe(he, e.__scopeMenu), s = Ht(he, e.__scopeMenu);
    return /* @__PURE__ */ m($t.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ m(nt, { present: r || i.open, children: /* @__PURE__ */ m($t.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ m(tp, { ...o, ref: t }) : /* @__PURE__ */ m(np, { ...o, ref: t }) }) }) });
  }
), tp = c.forwardRef(
  (e, t) => {
    const n = qe(he, e.__scopeMenu), r = c.useRef(null), o = Q(t, r);
    return c.useEffect(() => {
      const i = r.current;
      if (i)
        return Ea(i);
    }, []), /* @__PURE__ */ m(
      qr,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: L(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), np = c.forwardRef((e, t) => {
  const n = qe(he, e.__scopeMenu);
  return /* @__PURE__ */ m(
    qr,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), rp = /* @__PURE__ */ Jd("MenuContent.ScrollLock"), qr = c.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEntryFocus: u,
      onEscapeKeyDown: l,
      onPointerDownOutside: d,
      onFocusOutside: f,
      onInteractOutside: p,
      onDismiss: v,
      disableOutsideScroll: w,
      ...h
    } = e, g = qe(he, n), y = Ht(he, n), E = zt(n), x = _a(n), b = Xf(n), [S, N] = c.useState(null), C = c.useRef(null), R = Q(t, C, g.onContentChange), O = c.useRef(0), I = c.useRef(""), $ = c.useRef(0), D = c.useRef(null), A = c.useRef("right"), P = c.useRef(0), F = w ? Oa : c.Fragment, k = w ? { as: rp, allowPinchZoom: !0 } : void 0, V = (M) => {
      var le, ve;
      const j = I.current + M, G = b().filter((ae) => !ae.disabled), oe = document.activeElement, ie = (le = G.find((ae) => ae.ref.current === oe)) == null ? void 0 : le.textValue, fe = G.map((ae) => ae.textValue), Le = hp(fe, j, ie), ge = (ve = G.find((ae) => ae.textValue === Le)) == null ? void 0 : ve.ref.current;
      (function ae(Oe) {
        I.current = Oe, window.clearTimeout(O.current), Oe !== "" && (O.current = window.setTimeout(() => ae(""), 1e3));
      })(j), ge && setTimeout(() => ge.focus());
    };
    c.useEffect(() => () => window.clearTimeout(O.current), []), Eu();
    const _ = c.useCallback((M) => {
      var G, oe;
      return A.current === ((G = D.current) == null ? void 0 : G.side) && vp(M, (oe = D.current) == null ? void 0 : oe.area);
    }, []);
    return /* @__PURE__ */ m(
      ep,
      {
        scope: n,
        searchRef: I,
        onItemEnter: c.useCallback(
          (M) => {
            _(M) && M.preventDefault();
          },
          [_]
        ),
        onItemLeave: c.useCallback(
          (M) => {
            var j;
            _(M) || ((j = C.current) == null || j.focus(), N(null));
          },
          [_]
        ),
        onTriggerLeave: c.useCallback(
          (M) => {
            _(M) && M.preventDefault();
          },
          [_]
        ),
        pointerGraceTimerRef: $,
        onPointerGraceIntentChange: c.useCallback((M) => {
          D.current = M;
        }, []),
        children: /* @__PURE__ */ m(F, { ...k, children: /* @__PURE__ */ m(
          Hi,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: L(i, (M) => {
              var j;
              M.preventDefault(), (j = C.current) == null || j.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ m(
              Ui,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: l,
                onPointerDownOutside: d,
                onFocusOutside: f,
                onInteractOutside: p,
                onDismiss: v,
                children: /* @__PURE__ */ m(
                  Zd,
                  {
                    asChild: !0,
                    ...x,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: N,
                    onEntryFocus: L(u, (M) => {
                      y.isUsingKeyboardRef.current || M.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ m(
                      Fd,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": ns(g.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...E,
                        ...h,
                        ref: R,
                        style: { outline: "none", ...h.style },
                        onKeyDown: L(h.onKeyDown, (M) => {
                          const G = M.target.closest("[data-radix-menu-content]") === M.currentTarget, oe = M.ctrlKey || M.altKey || M.metaKey, ie = M.key.length === 1;
                          G && (M.key === "Tab" && M.preventDefault(), !oe && ie && V(M.key));
                          const fe = C.current;
                          if (M.target !== fe || !Kf.includes(M.key))
                            return;
                          M.preventDefault();
                          const ge = b().filter((le) => !le.disabled).map((le) => le.ref.current);
                          Da.includes(M.key) && ge.reverse(), pp(ge);
                        }),
                        onBlur: L(e.onBlur, (M) => {
                          M.currentTarget.contains(M.target) || (window.clearTimeout(O.current), I.current = "");
                        }),
                        onPointerMove: L(
                          e.onPointerMove,
                          Lt((M) => {
                            const j = M.target, G = P.current !== M.clientX;
                            if (M.currentTarget.contains(j) && G) {
                              const oe = M.clientX > P.current ? "right" : "left";
                              A.current = oe, P.current = M.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ba.displayName = he;
var op = "MenuGroup", Zr = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ m(re.div, { role: "group", ...r, ref: t });
  }
);
Zr.displayName = op;
var ip = "MenuLabel", Wa = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ m(re.div, { ...r, ref: t });
  }
);
Wa.displayName = ip;
var vn = "MenuItem", Xo = "menu.itemSelect", Nn = c.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = c.useRef(null), s = Ht(vn, e.__scopeMenu), a = Xr(vn, e.__scopeMenu), u = Q(t, i), l = c.useRef(!1), d = () => {
      const f = i.current;
      if (!n && f) {
        const p = new CustomEvent(Xo, { bubbles: !0, cancelable: !0 });
        f.addEventListener(Xo, (v) => r == null ? void 0 : r(v), { once: !0 }), Di(f, p), p.defaultPrevented ? l.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ m(
      Va,
      {
        ...o,
        ref: u,
        disabled: n,
        onClick: L(e.onClick, d),
        onPointerDown: (f) => {
          var p;
          (p = e.onPointerDown) == null || p.call(e, f), l.current = !0;
        },
        onPointerUp: L(e.onPointerUp, (f) => {
          var p;
          l.current || (p = f.currentTarget) == null || p.click();
        }),
        onKeyDown: L(e.onKeyDown, (f) => {
          const p = a.searchRef.current !== "";
          n || p && f.key === " " || hr.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
Nn.displayName = vn;
var Va = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, s = Xr(vn, n), a = _a(n), u = c.useRef(null), l = Q(t, u), [d, f] = c.useState(!1), [p, v] = c.useState("");
    return c.useEffect(() => {
      const w = u.current;
      w && v((w.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ m(
      $t.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? p,
        children: /* @__PURE__ */ m(Qd, { asChild: !0, ...a, focusable: !r, children: /* @__PURE__ */ m(
          re.div,
          {
            role: "menuitem",
            "data-highlighted": d ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: l,
            onPointerMove: L(
              e.onPointerMove,
              Lt((w) => {
                r ? s.onItemLeave(w) : (s.onItemEnter(w), w.defaultPrevented || w.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: L(
              e.onPointerLeave,
              Lt((w) => s.onItemLeave(w))
            ),
            onFocus: L(e.onFocus, () => f(!0)),
            onBlur: L(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), ap = "MenuCheckboxItem", Ua = c.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ m(Ga, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ m(
      Nn,
      {
        role: "menuitemcheckbox",
        "aria-checked": yn(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": eo(n),
        onSelect: L(
          o.onSelect,
          () => r == null ? void 0 : r(yn(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ua.displayName = ap;
var za = "MenuRadioGroup", [sp, cp] = rt(
  za,
  { value: void 0, onValueChange: () => {
  } }
), Ha = c.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = se(r);
    return /* @__PURE__ */ m(sp, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ m(Zr, { ...o, ref: t }) });
  }
);
Ha.displayName = za;
var ja = "MenuRadioItem", Ka = c.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = cp(ja, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ m(Ga, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ m(
      Nn,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": eo(i),
        onSelect: L(
          r.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ka.displayName = ja;
var Qr = "MenuItemIndicator", [Ga, lp] = rt(
  Qr,
  { checked: !1 }
), Ya = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = lp(Qr, n);
    return /* @__PURE__ */ m(
      nt,
      {
        present: r || yn(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ m(
          re.span,
          {
            ...o,
            ref: t,
            "data-state": eo(i.checked)
          }
        )
      }
    );
  }
);
Ya.displayName = Qr;
var up = "MenuSeparator", Xa = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ m(
      re.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Xa.displayName = up;
var dp = "MenuArrow", qa = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = zt(n);
    return /* @__PURE__ */ m(Bd, { ...o, ...r, ref: t });
  }
);
qa.displayName = dp;
var Jr = "MenuSub", [fp, Za] = rt(Jr), Qa = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, i = qe(Jr, t), s = zt(t), [a, u] = c.useState(null), [l, d] = c.useState(null), f = se(o);
  return c.useEffect(() => (i.open === !1 && f(!1), () => f(!1)), [i.open, f]), /* @__PURE__ */ m(pa, { ...s, children: /* @__PURE__ */ m(
    ka,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: l,
      onContentChange: d,
      children: /* @__PURE__ */ m(
        fp,
        {
          scope: t,
          contentId: It(),
          triggerId: It(),
          trigger: a,
          onTriggerChange: u,
          children: n
        }
      )
    }
  ) });
};
Qa.displayName = Jr;
var Pt = "MenuSubTrigger", Ja = c.forwardRef(
  (e, t) => {
    const n = qe(Pt, e.__scopeMenu), r = Ht(Pt, e.__scopeMenu), o = Za(Pt, e.__scopeMenu), i = Xr(Pt, e.__scopeMenu), s = c.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: u } = i, l = { __scopeMenu: e.__scopeMenu }, d = c.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return c.useEffect(() => d, [d]), c.useEffect(() => {
      const f = a.current;
      return () => {
        window.clearTimeout(f), u(null);
      };
    }, [a, u]), /* @__PURE__ */ m(Gr, { asChild: !0, ...l, children: /* @__PURE__ */ m(
      Va,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": ns(n.open),
        ...e,
        ref: tt(t, o.onTriggerChange),
        onClick: (f) => {
          var p;
          (p = e.onClick) == null || p.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: L(
          e.onPointerMove,
          Lt((f) => {
            i.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !s.current && (i.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), d();
            }, 100));
          })
        ),
        onPointerLeave: L(
          e.onPointerLeave,
          Lt((f) => {
            var v, w;
            d();
            const p = (v = n.content) == null ? void 0 : v.getBoundingClientRect();
            if (p) {
              const h = (w = n.content) == null ? void 0 : w.dataset.side, g = h === "right", y = g ? -5 : 5, E = p[g ? "left" : "right"], x = p[g ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + y, y: f.clientY },
                  { x: E, y: p.top },
                  { x, y: p.top },
                  { x, y: p.bottom },
                  { x: E, y: p.bottom }
                ],
                side: h
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(f), f.defaultPrevented)
                return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: L(e.onKeyDown, (f) => {
          var v;
          const p = i.searchRef.current !== "";
          e.disabled || p && f.key === " " || Gf[r.dir].includes(f.key) && (n.onOpenChange(!0), (v = n.content) == null || v.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
Ja.displayName = Pt;
var es = "MenuSubContent", ts = c.forwardRef(
  (e, t) => {
    const n = La(he, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = qe(he, e.__scopeMenu), s = Ht(he, e.__scopeMenu), a = Za(es, e.__scopeMenu), u = c.useRef(null), l = Q(t, u);
    return /* @__PURE__ */ m($t.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ m(nt, { present: r || i.open, children: /* @__PURE__ */ m($t.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ m(
      qr,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...o,
        ref: l,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (d) => {
          var f;
          s.isUsingKeyboardRef.current && ((f = u.current) == null || f.focus()), d.preventDefault();
        },
        onCloseAutoFocus: (d) => d.preventDefault(),
        onFocusOutside: L(e.onFocusOutside, (d) => {
          d.target !== a.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: L(e.onEscapeKeyDown, (d) => {
          s.onClose(), d.preventDefault();
        }),
        onKeyDown: L(e.onKeyDown, (d) => {
          var v;
          const f = d.currentTarget.contains(d.target), p = Yf[s.dir].includes(d.key);
          f && p && (i.onOpenChange(!1), (v = a.trigger) == null || v.focus(), d.preventDefault());
        })
      }
    ) }) }) });
  }
);
ts.displayName = es;
function ns(e) {
  return e ? "open" : "closed";
}
function yn(e) {
  return e === "indeterminate";
}
function eo(e) {
  return yn(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function pp(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function mp(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function hp(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = mp(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((l) => l !== n));
  const u = s.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function gp(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i], u = t[s], l = a.x, d = a.y, f = u.x, p = u.y;
    d > r != p > r && n < (f - l) * (r - d) / (p - d) + l && (o = !o);
  }
  return o;
}
function vp(e, t) {
  if (!t)
    return !1;
  const n = { x: e.clientX, y: e.clientY };
  return gp(n, t);
}
function Lt(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var yp = $a, bp = Gr, wp = Fa, xp = Ba, Ep = Zr, Cp = Wa, Sp = Nn, Rp = Ua, Tp = Ha, Np = Ka, Pp = Ya, Ap = Xa, Mp = qa, Op = Qa, Dp = Ja, Ip = ts, Pn = "DropdownMenu", [_p, vv] = Xe(
  Pn,
  [Ia]
), ce = Ia(), [kp, rs] = _p(Pn), os = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: s,
    modal: a = !0
  } = e, u = ce(t), l = c.useRef(null), [d, f] = Bt({
    prop: o,
    defaultProp: i ?? !1,
    onChange: s,
    caller: Pn
  });
  return /* @__PURE__ */ m(
    kp,
    {
      scope: t,
      triggerId: It(),
      triggerRef: l,
      contentId: It(),
      open: d,
      onOpenChange: f,
      onOpenToggle: c.useCallback(() => f((p) => !p), [f]),
      modal: a,
      children: /* @__PURE__ */ m(yp, { ...u, open: d, onOpenChange: f, dir: r, modal: a, children: n })
    }
  );
};
os.displayName = Pn;
var is = "DropdownMenuTrigger", as = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = rs(is, n), s = ce(n);
    return /* @__PURE__ */ m(bp, { asChild: !0, ...s, children: /* @__PURE__ */ m(
      re.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: tt(t, i.triggerRef),
        onPointerDown: L(e.onPointerDown, (a) => {
          !r && a.button === 0 && a.ctrlKey === !1 && (i.onOpenToggle(), i.open || a.preventDefault());
        }),
        onKeyDown: L(e.onKeyDown, (a) => {
          r || (["Enter", " "].includes(a.key) && i.onOpenToggle(), a.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
as.displayName = is;
var $p = "DropdownMenuPortal", ss = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = ce(t);
  return /* @__PURE__ */ m(wp, { ...r, ...n });
};
ss.displayName = $p;
var cs = "DropdownMenuContent", ls = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = rs(cs, n), i = ce(n), s = c.useRef(!1);
    return /* @__PURE__ */ m(
      xp,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: L(e.onCloseAutoFocus, (a) => {
          var u;
          s.current || (u = o.triggerRef.current) == null || u.focus(), s.current = !1, a.preventDefault();
        }),
        onInteractOutside: L(e.onInteractOutside, (a) => {
          const u = a.detail.originalEvent, l = u.button === 0 && u.ctrlKey === !0, d = u.button === 2 || l;
          (!o.modal || d) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
ls.displayName = cs;
var Lp = "DropdownMenuGroup", us = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ m(Ep, { ...o, ...r, ref: t });
  }
);
us.displayName = Lp;
var Fp = "DropdownMenuLabel", ds = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ m(Cp, { ...o, ...r, ref: t });
  }
);
ds.displayName = Fp;
var Bp = "DropdownMenuItem", fs = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ m(Sp, { ...o, ...r, ref: t });
  }
);
fs.displayName = Bp;
var Wp = "DropdownMenuCheckboxItem", ps = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ m(Rp, { ...o, ...r, ref: t });
});
ps.displayName = Wp;
var Vp = "DropdownMenuRadioGroup", ms = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ m(Tp, { ...o, ...r, ref: t });
});
ms.displayName = Vp;
var Up = "DropdownMenuRadioItem", hs = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ m(Np, { ...o, ...r, ref: t });
});
hs.displayName = Up;
var zp = "DropdownMenuItemIndicator", gs = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ m(Pp, { ...o, ...r, ref: t });
});
gs.displayName = zp;
var Hp = "DropdownMenuSeparator", vs = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ m(Ap, { ...o, ...r, ref: t });
});
vs.displayName = Hp;
var jp = "DropdownMenuArrow", Kp = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ m(Mp, { ...o, ...r, ref: t });
  }
);
Kp.displayName = jp;
var Gp = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: i } = e, s = ce(t), [a, u] = Bt({
    prop: r,
    defaultProp: i ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ m(Op, { ...s, open: a, onOpenChange: u, children: n });
}, Yp = "DropdownMenuSubTrigger", ys = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ m(Dp, { ...o, ...r, ref: t });
});
ys.displayName = Yp;
var Xp = "DropdownMenuSubContent", bs = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ m(
    Ip,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
bs.displayName = Xp;
var qp = os, ws = as, xs = ss, Es = ls, Zp = us, Cs = ds, Ss = fs, Rs = ps, Qp = ms, Ts = hs, Ns = gs, Ps = vs, Jp = Gp, As = ys, Ms = bs;
const _e = ({ name: e, size: t, color: n, filled: r, onClick: o, rotate: i = 0, className: s }) => /* @__PURE__ */ m(
  "div",
  {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: t ? `${t}px` : void 0,
      transform: i ? `rotate(${i}deg)` : void 0
    },
    onClick: o,
    children: /* @__PURE__ */ m(
      "span",
      {
        className: W("material-symbols-rounded", s),
        style: {
          fontSize: t ? `${t}px` : void 0,
          color: n,
          overflow: "hidden",
          fontVariationSettings: r ? "'FILL' 1" : "'FILL' 0"
        },
        children: e
      }
    )
  }
), em = (e) => /* @__PURE__ */ c.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ c.createElement("g", { id: "CheckItem" }, /* @__PURE__ */ c.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M18.2961 4.5363C18.8284 4.97598 18.9034 5.76387 18.4637 6.29611L8.96375 17.7961C8.7241 18.0862 8.36651 18.2529 7.99023 18.25C7.61395 18.247 7.25903 18.0747 7.02396 17.7809L3.02396 12.7809C2.5927 12.2418 2.6801 11.4552 3.21918 11.0239C3.75825 10.5927 4.54487 10.6801 4.97613 11.2191L8.01561 15.0185L16.5363 4.7039C16.976 4.17166 17.7639 4.09663 18.2961 4.5363Z", fill: "#FD7E14" }))), tm = ({ size: e = 22, className: t, ...n }) => /* @__PURE__ */ m(em, { width: e, height: e, className: t, ...n });
function Mt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function qo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function nm(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = qo(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : qo(e[o], null);
        }
      };
  };
}
function An(...e) {
  return c.useCallback(nm(...e), e);
}
function rm(e, t) {
  const n = c.createContext(t), r = (i) => {
    const { children: s, ...a } = i, u = c.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ m(n.Provider, { value: u, children: s });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const s = c.useContext(n);
    if (s)
      return s;
    if (t !== void 0)
      return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function om(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = c.createContext(s), u = n.length;
    n = [...n, s];
    const l = (f) => {
      var y;
      const { scope: p, children: v, ...w } = f, h = ((y = p == null ? void 0 : p[e]) == null ? void 0 : y[u]) || a, g = c.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ m(h.Provider, { value: g, children: v });
    };
    l.displayName = i + "Provider";
    function d(f, p) {
      var h;
      const v = ((h = p == null ? void 0 : p[e]) == null ? void 0 : h[u]) || a, w = c.useContext(v);
      if (w)
        return w;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [l, d];
  }
  const o = () => {
    const i = n.map((s) => c.createContext(s));
    return function(a) {
      const u = (a == null ? void 0 : a[e]) || i;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: u } }),
        [a, u]
      );
    };
  };
  return o.scopeName = e, [r, im(o, ...t)];
}
function im(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: u, scopeName: l }) => {
        const f = u(i)[`__scope${l}`];
        return { ...a, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var gr = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, am = c["useId".toString()] || (() => {
}), sm = 0;
function jn(e) {
  const [t, n] = c.useState(am());
  return gr(() => {
    e || n((r) => r ?? String(sm++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function Os(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function cm({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = lm({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, a = Os(n), u = c.useCallback(
    (l) => {
      if (i) {
        const f = typeof l == "function" ? l(e) : l;
        f !== e && a(f);
      } else
        o(l);
    },
    [i, e, o, a]
  );
  return [s, u];
}
function lm({
  defaultProp: e,
  onChange: t
}) {
  const n = c.useState(e), [r] = n, o = c.useRef(r), i = Os(t);
  return c.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
function Kn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Zo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function um(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Zo(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Zo(e[o], null);
        }
      };
  };
}
var yt = c.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = c.Children.toArray(n), i = o.find(fm);
  if (i) {
    const s = i.props.children, a = o.map((u) => u === i ? c.Children.count(s) > 1 ? c.Children.only(null) : c.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ m(vr, { ...r, ref: t, children: c.isValidElement(s) ? c.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ m(vr, { ...r, ref: t, children: n });
});
yt.displayName = "Slot";
var vr = c.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (c.isValidElement(n)) {
    const o = mm(n), i = pm(r, n.props);
    return n.type !== c.Fragment && (i.ref = t ? um(t, o) : o), c.cloneElement(n, i);
  }
  return c.Children.count(n) > 1 ? c.Children.only(null) : null;
});
vr.displayName = "SlotClone";
var dm = ({ children: e }) => /* @__PURE__ */ m(pt, { children: e });
function fm(e) {
  return c.isValidElement(e) && e.type === dm;
}
function pm(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function mm(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var hm = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ds = hm.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, a = i ? yt : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(a, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function gm(e, t) {
  e && Ft.flushSync(() => e.dispatchEvent(t));
}
function Qo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function vm(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Qo(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Qo(e[o], null);
        }
      };
  };
}
function Is(...e) {
  return c.useCallback(vm(...e), e);
}
function to(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function ym(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = to(e);
  c.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var bm = "DismissableLayer", yr = "dismissableLayer.update", wm = "dismissableLayer.pointerDownOutside", xm = "dismissableLayer.focusOutside", Jo, _s = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ks = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...u
    } = e, l = c.useContext(_s), [d, f] = c.useState(null), p = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = c.useState({}), w = Is(t, (C) => f(C)), h = Array.from(l.layers), [g] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = h.indexOf(g), E = d ? h.indexOf(d) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, b = E >= y, S = Sm((C) => {
      const R = C.target, O = [...l.branches].some((I) => I.contains(R));
      !b || O || (o == null || o(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, p), N = Rm((C) => {
      const R = C.target;
      [...l.branches].some((I) => I.contains(R)) || (i == null || i(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, p);
    return ym((C) => {
      E === l.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && a && (C.preventDefault(), a()));
    }, p), c.useEffect(() => {
      if (d)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Jo = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), ei(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = Jo);
        };
    }, [d, p, n, l]), c.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), ei());
    }, [d, l]), c.useEffect(() => {
      const C = () => v({});
      return document.addEventListener(yr, C), () => document.removeEventListener(yr, C);
    }, []), /* @__PURE__ */ m(
      Ds.div,
      {
        ...u,
        ref: w,
        style: {
          pointerEvents: x ? b ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Kn(e.onFocusCapture, N.onFocusCapture),
        onBlurCapture: Kn(e.onBlurCapture, N.onBlurCapture),
        onPointerDownCapture: Kn(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
ks.displayName = bm;
var Em = "DismissableLayerBranch", Cm = c.forwardRef((e, t) => {
  const n = c.useContext(_s), r = c.useRef(null), o = Is(t, r);
  return c.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ m(Ds.div, { ...e, ref: o });
});
Cm.displayName = Em;
function Sm(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = to(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let u = function() {
          $s(
            wm,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Rm(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = to(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && $s(xm, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function ei() {
  const e = new CustomEvent(yr);
  document.dispatchEvent(e);
}
function $s(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? gm(o, i) : o.dispatchEvent(i);
}
function ti(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Tm(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = ti(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : ti(e[o], null);
        }
      };
  };
}
function Nm(...e) {
  return c.useCallback(Tm(...e), e);
}
var Pm = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Am = Pm.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, a = i ? yt : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(a, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function ni(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var Gn = "focusScope.autoFocusOnMount", Yn = "focusScope.autoFocusOnUnmount", ri = { bubbles: !1, cancelable: !0 }, Mm = "FocusScope", Ls = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, u] = c.useState(null), l = ni(o), d = ni(i), f = c.useRef(null), p = Nm(t, (h) => u(h)), v = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let h = function(x) {
        if (v.paused || !a)
          return;
        const b = x.target;
        a.contains(b) ? f.current = b : He(f.current, { select: !0 });
      }, g = function(x) {
        if (v.paused || !a)
          return;
        const b = x.relatedTarget;
        b !== null && (a.contains(b) || He(f.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && He(a);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", g);
      const E = new MutationObserver(y);
      return a && E.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", g), E.disconnect();
      };
    }
  }, [r, a, v.paused]), c.useEffect(() => {
    if (a) {
      ii.add(v);
      const h = document.activeElement;
      if (!a.contains(h)) {
        const y = new CustomEvent(Gn, ri);
        a.addEventListener(Gn, l), a.dispatchEvent(y), y.defaultPrevented || (Om($m(Fs(a)), { select: !0 }), document.activeElement === h && He(a));
      }
      return () => {
        a.removeEventListener(Gn, l), setTimeout(() => {
          const y = new CustomEvent(Yn, ri);
          a.addEventListener(Yn, d), a.dispatchEvent(y), y.defaultPrevented || He(h ?? document.body, { select: !0 }), a.removeEventListener(Yn, d), ii.remove(v);
        }, 0);
      };
    }
  }, [a, l, d, v]);
  const w = c.useCallback(
    (h) => {
      if (!n && !r || v.paused)
        return;
      const g = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, y = document.activeElement;
      if (g && y) {
        const E = h.currentTarget, [x, b] = Dm(E);
        x && b ? !h.shiftKey && y === b ? (h.preventDefault(), n && He(x, { select: !0 })) : h.shiftKey && y === x && (h.preventDefault(), n && He(b, { select: !0 })) : y === E && h.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ m(Am.div, { tabIndex: -1, ...s, ref: p, onKeyDown: w });
});
Ls.displayName = Mm;
function Om(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (He(r, { select: t }), document.activeElement !== n)
      return;
}
function Dm(e) {
  const t = Fs(e), n = oi(t, e), r = oi(t.reverse(), e);
  return [n, r];
}
function Fs(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function oi(e, t) {
  for (const n of e)
    if (!Im(n, { upTo: t }))
      return n;
}
function Im(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function _m(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function He(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && _m(e) && t && e.select();
  }
}
var ii = km();
function km() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = ai(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = ai(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function ai(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function $m(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Lm = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Fm = Lm.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, a = i ? yt : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(a, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Bm = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, Wm = "Portal", Bs = c.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = c.useState(!1);
  Bm(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? kr.createPortal(/* @__PURE__ */ m(Fm.div, { ...r, ref: t }), s) : null;
});
Bs.displayName = Wm;
function Vm(e, t) {
  return c.useReducer((n, r) => t[n][r] ?? n, e);
}
var Mn = (e) => {
  const { present: t, children: n } = e, r = Um(t), o = typeof n == "function" ? n({ present: r.isPresent }) : c.Children.only(n), i = An(r.ref, zm(o));
  return typeof n == "function" || r.isPresent ? c.cloneElement(o, { ref: i }) : null;
};
Mn.displayName = "Presence";
function Um(e) {
  const [t, n] = c.useState(), r = c.useRef({}), o = c.useRef(e), i = c.useRef("none"), s = e ? "mounted" : "unmounted", [a, u] = Vm(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const l = rn(r.current);
    i.current = a === "mounted" ? l : "none";
  }, [a]), gr(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const p = i.current, v = rn(l);
      e ? u("MOUNT") : v === "none" || (l == null ? void 0 : l.display) === "none" ? u("UNMOUNT") : u(d && p !== v ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), gr(() => {
    if (t) {
      let l;
      const d = t.ownerDocument.defaultView ?? window, f = (v) => {
        const h = rn(r.current).includes(v.animationName);
        if (v.target === t && h && (u("ANIMATION_END"), !o.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, p = (v) => {
        v.target === t && (i.current = rn(r.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(l), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: c.useCallback((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function rn(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function zm(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Hm = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], jt = Hm.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, a = i ? yt : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(a, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Xn = 0;
function jm() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? si()), document.body.insertAdjacentElement("beforeend", e[1] ?? si()), Xn++, () => {
      Xn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Xn--;
    };
  }, []);
}
function si() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var no = "Dialog", [Ws, yv] = om(no), [Km, Ee] = Ws(no), Vs = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, a = c.useRef(null), u = c.useRef(null), [l = !1, d] = cm({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ m(
    Km,
    {
      scope: t,
      triggerRef: a,
      contentRef: u,
      contentId: jn(),
      titleId: jn(),
      descriptionId: jn(),
      open: l,
      onOpenChange: d,
      onOpenToggle: c.useCallback(() => d((f) => !f), [d]),
      modal: s,
      children: n
    }
  );
};
Vs.displayName = no;
var Us = "DialogTrigger", zs = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ee(Us, n), i = An(t, o.triggerRef);
    return /* @__PURE__ */ m(
      jt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": io(o.open),
        ...r,
        ref: i,
        onClick: Mt(e.onClick, o.onOpenToggle)
      }
    );
  }
);
zs.displayName = Us;
var ro = "DialogPortal", [Gm, Hs] = Ws(ro, {
  forceMount: void 0
}), js = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = Ee(ro, t);
  return /* @__PURE__ */ m(Gm, { scope: t, forceMount: n, children: c.Children.map(r, (s) => /* @__PURE__ */ m(Mn, { present: n || i.open, children: /* @__PURE__ */ m(Bs, { asChild: !0, container: o, children: s }) })) });
};
js.displayName = ro;
var bn = "DialogOverlay", Ks = c.forwardRef(
  (e, t) => {
    const n = Hs(bn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Ee(bn, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ m(Mn, { present: r || i.open, children: /* @__PURE__ */ m(Ym, { ...o, ref: t }) }) : null;
  }
);
Ks.displayName = bn;
var Ym = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ee(bn, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ m(Oa, { as: yt, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ m(
        jt.div,
        {
          "data-state": io(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), et = "DialogContent", Gs = c.forwardRef(
  (e, t) => {
    const n = Hs(et, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Ee(et, e.__scopeDialog);
    return /* @__PURE__ */ m(Mn, { present: r || i.open, children: i.modal ? /* @__PURE__ */ m(Xm, { ...o, ref: t }) : /* @__PURE__ */ m(qm, { ...o, ref: t }) });
  }
);
Gs.displayName = et;
var Xm = c.forwardRef(
  (e, t) => {
    const n = Ee(et, e.__scopeDialog), r = c.useRef(null), o = An(t, n.contentRef, r);
    return c.useEffect(() => {
      const i = r.current;
      if (i)
        return Ea(i);
    }, []), /* @__PURE__ */ m(
      Ys,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Mt(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: Mt(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && i.preventDefault();
        }),
        onFocusOutside: Mt(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), qm = c.forwardRef(
  (e, t) => {
    const n = Ee(et, e.__scopeDialog), r = c.useRef(!1), o = c.useRef(!1);
    return /* @__PURE__ */ m(
      Ys,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var u, l;
          (u = e.onInteractOutside) == null || u.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), Ys = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = Ee(et, n), u = c.useRef(null), l = An(t, u);
    return jm(), /* @__PURE__ */ z(pt, { children: [
      /* @__PURE__ */ m(
        Ls,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ m(
            ks,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": io(a.open),
              ...s,
              ref: l,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ z(pt, { children: [
        /* @__PURE__ */ m(Zm, { titleId: a.titleId }),
        /* @__PURE__ */ m(Jm, { contentRef: u, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), oo = "DialogTitle", Xs = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ee(oo, n);
    return /* @__PURE__ */ m(jt.h2, { id: o.titleId, ...r, ref: t });
  }
);
Xs.displayName = oo;
var qs = "DialogDescription", Zs = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ee(qs, n);
    return /* @__PURE__ */ m(jt.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Zs.displayName = qs;
var Qs = "DialogClose", Js = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ee(Qs, n);
    return /* @__PURE__ */ m(
      jt.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Mt(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Js.displayName = Qs;
function io(e) {
  return e ? "open" : "closed";
}
var ec = "DialogTitleWarning", [bv, tc] = rm(ec, {
  contentName: et,
  titleName: oo,
  docsSlug: "dialog"
}), Zm = ({ titleId: e }) => {
  const t = tc(ec), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return c.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Qm = "DialogDescriptionWarning", Jm = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${tc(Qm).contentName}}.`;
  return c.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, eh = Vs, th = zs, nh = js, rh = Ks, oh = Gs, ih = Xs, ah = Zs, sh = Js;
function ch(e) {
  if (!e || typeof document > "u")
    return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const nc = T.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), bt = () => {
  const e = T.useContext(nc);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
ch(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function lh() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function uh() {
  return ao(/^Mac/);
}
function dh() {
  return ao(/^iPhone/);
}
function ci() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function fh() {
  return ao(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  uh() && navigator.maxTouchPoints > 1;
}
function rc() {
  return dh() || fh();
}
function ao(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const ph = 24, mh = typeof window < "u" ? yi : be;
function li(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const qn = typeof document < "u" && window.visualViewport;
function ui(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function oc(e) {
  for (ui(e) && (e = e.parentElement); e && !ui(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const hh = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let on = 0, Zn;
function gh(e = {}) {
  let { isDisabled: t } = e;
  mh(() => {
    if (!t)
      return on++, on === 1 && rc() && (Zn = vh()), () => {
        on--, on === 0 && (Zn == null || Zn());
      };
  }, [
    t
  ]);
}
function vh() {
  let e, t = 0, n = (f) => {
    e = oc(f.target), !(e === document.documentElement && e === document.body) && (t = f.changedTouches[0].pageY);
  }, r = (f) => {
    if (!e || e === document.documentElement || e === document.body) {
      f.preventDefault();
      return;
    }
    let p = f.changedTouches[0].pageY, v = e.scrollTop, w = e.scrollHeight - e.clientHeight;
    w !== 0 && ((v <= 0 && p > t || v >= w && p < t) && f.preventDefault(), t = p);
  }, o = (f) => {
    let p = f.target;
    br(p) && p !== document.activeElement && (f.preventDefault(), p.style.transform = "translateY(-2000px)", p.focus(), requestAnimationFrame(() => {
      p.style.transform = "";
    }));
  }, i = (f) => {
    let p = f.target;
    br(p) && (p.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      p.style.transform = "", qn && (qn.height < window.innerHeight ? requestAnimationFrame(() => {
        di(p);
      }) : qn.addEventListener("resize", () => di(p), {
        once: !0
      }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, u = window.pageYOffset, l = li(yh(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let d = li(Tt(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), Tt(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), Tt(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), Tt(document, "focus", i, !0), Tt(window, "scroll", s));
  return () => {
    l(), d(), window.scrollTo(a, u);
  };
}
function yh(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Tt(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function di(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = oc(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, i = e.getBoundingClientRect().bottom;
      const s = n.getBoundingClientRect().bottom + ph;
      i > s && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function br(e) {
  return e instanceof HTMLInputElement && !hh.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function bh(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function wh(...e) {
  return (t) => e.forEach((n) => bh(n, t));
}
function ic(...e) {
  return c.useCallback(wh(...e), e);
}
const ac = /* @__PURE__ */ new WeakMap();
function te(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement))
    return;
  let r = {};
  Object.entries(t).forEach(([o, i]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, i);
      return;
    }
    r[o] = e.style[o], e.style[o] = i;
  }), !n && ac.set(e, r);
}
function xh(e, t) {
  if (!e || !(e instanceof HTMLElement))
    return;
  let n = ac.get(e);
  n && (e.style[t] = n[t]);
}
const ee = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function an(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[ee(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[ee(t) ? 5 : 4]) : null);
}
function Eh(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function Qn(e, t) {
  if (!e)
    return () => {
    };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function Ch(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const Z = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, sc = 0.4, Sh = 0.25, Rh = 100, cc = 8, Qe = 16, wr = 26, Jn = "vaul-dragging";
function lc(e) {
  const t = T.useRef(e);
  return T.useEffect(() => {
    t.current = e;
  }), T.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function Th({ defaultProp: e, onChange: t }) {
  const n = T.useState(e), [r] = n, o = T.useRef(r), i = lc(t);
  return T.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function uc({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = Th({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, a = lc(n), u = T.useCallback((l) => {
    if (i) {
      const f = typeof l == "function" ? l(e) : l;
      f !== e && a(f);
    } else
      o(l);
  }, [
    i,
    e,
    o,
    a
  ]);
  return [
    s,
    u
  ];
}
function Nh({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: i, onSnapPointChange: s, direction: a = "bottom", container: u, snapToSequentialPoint: l }) {
  const [d, f] = uc({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [p, v] = T.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  T.useEffect(() => {
    function C() {
      v({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", C), () => window.removeEventListener("resize", C);
  }, []);
  const w = T.useMemo(() => d === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    d
  ]), h = T.useMemo(() => {
    var C;
    return (C = n == null ? void 0 : n.findIndex((R) => R === d)) != null ? C : null;
  }, [
    n,
    d
  ]), g = n && n.length > 0 && (i || i === 0) && !Number.isNaN(i) && n[i] === d || !n, y = T.useMemo(() => {
    const C = u ? {
      width: u.getBoundingClientRect().width,
      height: u.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var R;
    return (R = n == null ? void 0 : n.map((O) => {
      const I = typeof O == "string";
      let $ = 0;
      if (I && ($ = parseInt(O, 10)), ee(a)) {
        const A = I ? $ : p ? O * C.height : 0;
        return p ? a === "bottom" ? C.height - A : -C.height + A : A;
      }
      const D = I ? $ : p ? O * C.width : 0;
      return p ? a === "right" ? C.width - D : -C.width + D : D;
    })) != null ? R : [];
  }, [
    n,
    p,
    u
  ]), E = T.useMemo(() => h !== null ? y == null ? void 0 : y[h] : null, [
    y,
    h
  ]), x = T.useCallback((C) => {
    var R;
    const O = (R = y == null ? void 0 : y.findIndex((I) => I === C)) != null ? R : null;
    s(O), te(r.current, {
      transition: `transform ${Z.DURATION}s cubic-bezier(${Z.EASE.join(",")})`,
      transform: ee(a) ? `translate3d(0, ${C}px, 0)` : `translate3d(${C}px, 0, 0)`
    }), y && O !== y.length - 1 && i !== void 0 && O !== i && O < i ? te(o.current, {
      transition: `opacity ${Z.DURATION}s cubic-bezier(${Z.EASE.join(",")})`,
      opacity: "0"
    }) : te(o.current, {
      transition: `opacity ${Z.DURATION}s cubic-bezier(${Z.EASE.join(",")})`,
      opacity: "1"
    }), f(n == null ? void 0 : n[Math.max(O, 0)]);
  }, [
    r.current,
    n,
    y,
    i,
    o,
    f
  ]);
  T.useEffect(() => {
    if (d || e) {
      var C;
      const R = (C = n == null ? void 0 : n.findIndex((O) => O === e || O === d)) != null ? C : -1;
      y && R !== -1 && typeof y[R] == "number" && x(y[R]);
    }
  }, [
    d,
    e,
    n,
    y,
    x
  ]);
  function b({ draggedDistance: C, closeDrawer: R, velocity: O, dismissible: I }) {
    if (i === void 0)
      return;
    const $ = a === "bottom" || a === "right" ? (E ?? 0) - C : (E ?? 0) + C, D = h === i - 1, A = h === 0, P = C > 0;
    if (D && te(o.current, {
      transition: `opacity ${Z.DURATION}s cubic-bezier(${Z.EASE.join(",")})`
    }), !l && O > 2 && !P) {
      I ? R() : x(y[0]);
      return;
    }
    if (!l && O > 2 && P && y && n) {
      x(y[n.length - 1]);
      return;
    }
    const F = y == null ? void 0 : y.reduce((V, _) => typeof V != "number" || typeof _ != "number" ? V : Math.abs(_ - $) < Math.abs(V - $) ? _ : V), k = ee(a) ? window.innerHeight : window.innerWidth;
    if (O > sc && Math.abs(C) < k * 0.4) {
      const V = P ? 1 : -1;
      if (V > 0 && w && n) {
        x(y[n.length - 1]);
        return;
      }
      if (A && V < 0 && I && R(), h === null)
        return;
      x(y[h + V]);
      return;
    }
    x(F);
  }
  function S({ draggedDistance: C }) {
    if (E === null)
      return;
    const R = a === "bottom" || a === "right" ? E - C : E + C;
    (a === "bottom" || a === "right") && R < y[y.length - 1] || (a === "top" || a === "left") && R > y[y.length - 1] || te(r.current, {
      transform: ee(a) ? `translate3d(0, ${R}px, 0)` : `translate3d(${R}px, 0, 0)`
    });
  }
  function N(C, R) {
    if (!n || typeof h != "number" || !y || i === void 0)
      return null;
    const O = h === i - 1;
    if (h >= i && R)
      return 0;
    if (O && !R)
      return 1;
    if (!g && !O)
      return null;
    const $ = O ? h + 1 : h - 1, D = O ? y[$] - y[$ - 1] : y[$ + 1] - y[$], A = C / Math.abs(D);
    return O ? 1 - A : A;
  }
  return {
    isLastSnapPoint: w,
    activeSnapPoint: d,
    shouldFade: g,
    getPercentageDragged: N,
    setActiveSnapPoint: f,
    activeSnapPointIndex: h,
    onRelease: b,
    onDrag: S,
    snapPointsOffset: y
  };
}
const Ph = () => () => {
};
function Ah() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = bt(), i = T.useRef(null), s = Dt(() => document.body.style.backgroundColor, []);
  function a() {
    return (window.innerWidth - wr) / window.innerWidth;
  }
  T.useEffect(() => {
    if (t && n) {
      i.current && clearTimeout(i.current);
      const u = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!u)
        return;
      Ch(r && !o ? Qn(document.body, {
        background: "black"
      }) : Ph, Qn(u, {
        transformOrigin: ee(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Z.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Z.EASE.join(",")})`
      }));
      const l = Qn(u, {
        borderRadius: `${cc}px`,
        overflow: "hidden",
        ...ee(e) ? {
          transform: `scale(${a()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${a()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        l(), i.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, Z.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    s
  ]);
}
let Nt = null;
function Mh({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: i }) {
  const [s, a] = T.useState(() => typeof window < "u" ? window.location.href : ""), u = T.useRef(0), l = T.useCallback(() => {
    if (ci() && Nt === null && e && !i) {
      Nt = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: f, innerHeight: p } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-u.current}px`,
        left: `${-f}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const v = p - window.innerHeight;
        v && u.current >= p && (document.body.style.top = `${-(u.current + v)}px`);
      }), 300);
    }
  }, [
    e
  ]), d = T.useCallback(() => {
    if (ci() && Nt !== null && !i) {
      const f = -parseInt(document.body.style.top, 10), p = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Nt), window.requestAnimationFrame(() => {
        if (o && s !== window.location.href) {
          a(window.location.href);
          return;
        }
        window.scrollTo(p, f);
      }), Nt = null;
    }
  }, [
    s
  ]);
  return T.useEffect(() => {
    function f() {
      u.current = window.scrollY;
    }
    return f(), window.addEventListener("scroll", f), () => {
      window.removeEventListener("scroll", f);
    };
  }, []), T.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || d();
      };
  }, [
    t,
    d
  ]), T.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && l(), t || window.setTimeout(() => {
      d();
    }, 500)) : d());
  }, [
    e,
    r,
    s,
    t,
    n,
    l,
    d
  ]), {
    restorePositionSetting: d
  };
}
function dc({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: i, shouldScaleBackground: s = !1, setBackgroundColorOnScale: a = !0, closeThreshold: u = Sh, scrollLockTimeout: l = Rh, dismissible: d = !0, handleOnly: f = !1, fadeFromIndex: p = i && i.length - 1, activeSnapPoint: v, setActiveSnapPoint: w, fixed: h, modal: g = !0, onClose: y, nested: E, noBodyStyles: x = !1, direction: b = "bottom", defaultOpen: S = !1, disablePreventScroll: N = !0, snapToSequentialPoint: C = !1, preventScrollRestoration: R = !1, repositionInputs: O = !0, onAnimationEnd: I, container: $, autoFocus: D = !1 }) {
  var A, P;
  const [F = !1, k] = uc({
    defaultProp: S,
    prop: e,
    onChange: (B) => {
      t == null || t(B), !B && !E && Xc(), setTimeout(() => {
        I == null || I(B);
      }, Z.DURATION * 1e3), B && !g && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), B || (document.body.style.pointerEvents = "auto");
    }
  }), [V, _] = T.useState(!1), [M, j] = T.useState(!1), [G, oe] = T.useState(!1), ie = T.useRef(null), fe = T.useRef(null), Le = T.useRef(null), ge = T.useRef(null), le = T.useRef(null), ve = T.useRef(!1), ae = T.useRef(null), Oe = T.useRef(0), De = T.useRef(!1), wt = T.useRef(!S), Fe = T.useRef(0), U = T.useRef(null), Gt = T.useRef(((A = U.current) == null ? void 0 : A.getBoundingClientRect().height) || 0), Yt = T.useRef(((P = U.current) == null ? void 0 : P.getBoundingClientRect().width) || 0), xt = T.useRef(0), In = T.useCallback((B) => {
    i && B === Et.length - 1 && (fe.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: ot, activeSnapPointIndex: it, setActiveSnapPoint: yo, onRelease: Kc, snapPointsOffset: Et, onDrag: Gc, shouldFade: bo, getPercentageDragged: Yc } = Nh({
    snapPoints: i,
    activeSnapPointProp: v,
    setActiveSnapPointProp: w,
    drawerRef: U,
    fadeFromIndex: p,
    overlayRef: ie,
    onSnapPointChange: In,
    direction: b,
    container: $,
    snapToSequentialPoint: C
  });
  gh({
    isDisabled: !F || M || !g || G || !V || !O || !N
  });
  const { restorePositionSetting: Xc } = Mh({
    isOpen: F,
    modal: g,
    nested: E ?? !1,
    hasBeenOpened: V,
    preventScrollRestoration: R,
    noBodyStyles: x
  });
  function Xt() {
    return (window.innerWidth - wr) / window.innerWidth;
  }
  function qc(B) {
    var Y, X;
    !d && !i || U.current && !U.current.contains(B.target) || (Gt.current = ((Y = U.current) == null ? void 0 : Y.getBoundingClientRect().height) || 0, Yt.current = ((X = U.current) == null ? void 0 : X.getBoundingClientRect().width) || 0, j(!0), Le.current = /* @__PURE__ */ new Date(), rc() && window.addEventListener("touchend", () => ve.current = !1, {
      once: !0
    }), B.target.setPointerCapture(B.pointerId), Oe.current = ee(b) ? B.pageY : B.pageX);
  }
  function wo(B, Y) {
    var X;
    let K = B;
    const J = (X = window.getSelection()) == null ? void 0 : X.toString(), de = U.current ? an(U.current, b) : null, ue = /* @__PURE__ */ new Date();
    if (K.tagName === "SELECT" || K.hasAttribute("data-vaul-no-drag") || K.closest("[data-vaul-no-drag]"))
      return !1;
    if (b === "right" || b === "left")
      return !0;
    if (fe.current && ue.getTime() - fe.current.getTime() < 500)
      return !1;
    if (de !== null && (b === "bottom" ? de > 0 : de < 0))
      return !0;
    if (J && J.length > 0)
      return !1;
    if (le.current && ue.getTime() - le.current.getTime() < l && de === 0 || Y)
      return le.current = ue, !1;
    for (; K; ) {
      if (K.scrollHeight > K.clientHeight) {
        if (K.scrollTop !== 0)
          return le.current = /* @__PURE__ */ new Date(), !1;
        if (K.getAttribute("role") === "dialog")
          return !0;
      }
      K = K.parentNode;
    }
    return !0;
  }
  function Zc(B) {
    if (U.current && M) {
      const Y = b === "bottom" || b === "right" ? 1 : -1, X = (Oe.current - (ee(b) ? B.pageY : B.pageX)) * Y, K = X > 0, J = i && !d && !K;
      if (J && it === 0)
        return;
      const de = Math.abs(X), ue = document.querySelector("[data-vaul-drawer-wrapper]"), Be = b === "bottom" || b === "top" ? Gt.current : Yt.current;
      let ye = de / Be;
      const Ze = Yc(de, K);
      if (Ze !== null && (ye = Ze), J && ye >= 1 || !ve.current && !wo(B.target, K))
        return;
      if (U.current.classList.add(Jn), ve.current = !0, te(U.current, {
        transition: "none"
      }), te(ie.current, {
        transition: "none"
      }), i && Gc({
        draggedDistance: X
      }), K && !i) {
        const Ce = Eh(X), qt = Math.min(Ce * -1, 0) * Y;
        te(U.current, {
          transform: ee(b) ? `translate3d(0, ${qt}px, 0)` : `translate3d(${qt}px, 0, 0)`
        });
        return;
      }
      const We = 1 - ye;
      if ((bo || p && it === p - 1) && (r == null || r(B, ye), te(ie.current, {
        opacity: `${We}`,
        transition: "none"
      }, !0)), ue && ie.current && s) {
        const Ce = Math.min(Xt() + ye * (1 - Xt()), 1), qt = 8 - ye * 8, Eo = Math.max(0, 14 - ye * 14);
        te(ue, {
          borderRadius: `${qt}px`,
          transform: ee(b) ? `scale(${Ce}) translate3d(0, ${Eo}px, 0)` : `scale(${Ce}) translate3d(${Eo}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!i) {
        const Ce = de * Y;
        te(U.current, {
          transform: ee(b) ? `translate3d(0, ${Ce}px, 0)` : `translate3d(${Ce}px, 0, 0)`
        });
      }
    }
  }
  T.useEffect(() => {
    window.requestAnimationFrame(() => {
      wt.current = !0;
    });
  }, []), T.useEffect(() => {
    var B;
    function Y() {
      if (!U.current || !O)
        return;
      const X = document.activeElement;
      if (br(X) || De.current) {
        var K;
        const J = ((K = window.visualViewport) == null ? void 0 : K.height) || 0, de = window.innerHeight;
        let ue = de - J;
        const Be = U.current.getBoundingClientRect().height || 0, ye = Be > de * 0.8;
        xt.current || (xt.current = Be);
        const Ze = U.current.getBoundingClientRect().top;
        if (Math.abs(Fe.current - ue) > 60 && (De.current = !De.current), i && i.length > 0 && Et && it) {
          const We = Et[it] || 0;
          ue += We;
        }
        if (Fe.current = ue, Be > J || De.current) {
          const We = U.current.getBoundingClientRect().height;
          let Ce = We;
          We > J && (Ce = J - (ye ? Ze : wr)), h ? U.current.style.height = `${We - Math.max(ue, 0)}px` : U.current.style.height = `${Math.max(Ce, J - Ze)}px`;
        } else
          lh() || (U.current.style.height = `${xt.current}px`);
        i && i.length > 0 && !De.current ? U.current.style.bottom = "0px" : U.current.style.bottom = `${Math.max(ue, 0)}px`;
      }
    }
    return (B = window.visualViewport) == null || B.addEventListener("resize", Y), () => {
      var X;
      return (X = window.visualViewport) == null ? void 0 : X.removeEventListener("resize", Y);
    };
  }, [
    it,
    i,
    Et
  ]);
  function Ct(B) {
    Qc(), y == null || y(), B || k(!1), setTimeout(() => {
      i && yo(i[0]);
    }, Z.DURATION * 1e3);
  }
  function xo() {
    if (!U.current)
      return;
    const B = document.querySelector("[data-vaul-drawer-wrapper]"), Y = an(U.current, b);
    te(U.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Z.DURATION}s cubic-bezier(${Z.EASE.join(",")})`
    }), te(ie.current, {
      transition: `opacity ${Z.DURATION}s cubic-bezier(${Z.EASE.join(",")})`,
      opacity: "1"
    }), s && Y && Y > 0 && F && te(B, {
      borderRadius: `${cc}px`,
      overflow: "hidden",
      ...ee(b) ? {
        transform: `scale(${Xt()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Xt()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Z.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Z.EASE.join(",")})`
    }, !0);
  }
  function Qc() {
    !M || !U.current || (U.current.classList.remove(Jn), ve.current = !1, j(!1), ge.current = /* @__PURE__ */ new Date());
  }
  function Jc(B) {
    if (!M || !U.current)
      return;
    U.current.classList.remove(Jn), ve.current = !1, j(!1), ge.current = /* @__PURE__ */ new Date();
    const Y = an(U.current, b);
    if (!B || !wo(B.target, !1) || !Y || Number.isNaN(Y) || Le.current === null)
      return;
    const X = ge.current.getTime() - Le.current.getTime(), K = Oe.current - (ee(b) ? B.pageY : B.pageX), J = Math.abs(K) / X;
    if (J > 0.05 && (oe(!0), setTimeout(() => {
      oe(!1);
    }, 200)), i) {
      Kc({
        draggedDistance: K * (b === "bottom" || b === "right" ? 1 : -1),
        closeDrawer: Ct,
        velocity: J,
        dismissible: d
      }), o == null || o(B, !0);
      return;
    }
    if (b === "bottom" || b === "right" ? K > 0 : K < 0) {
      xo(), o == null || o(B, !0);
      return;
    }
    if (J > sc) {
      Ct(), o == null || o(B, !1);
      return;
    }
    var de;
    const ue = Math.min((de = U.current.getBoundingClientRect().height) != null ? de : 0, window.innerHeight);
    var Be;
    const ye = Math.min((Be = U.current.getBoundingClientRect().width) != null ? Be : 0, window.innerWidth), Ze = b === "left" || b === "right";
    if (Math.abs(Y) >= (Ze ? ye : ue) * u) {
      Ct(), o == null || o(B, !1);
      return;
    }
    o == null || o(B, !0), xo();
  }
  T.useEffect(() => (F && (te(document.documentElement, {
    scrollBehavior: "auto"
  }), fe.current = /* @__PURE__ */ new Date()), () => {
    xh(document.documentElement, "scrollBehavior");
  }), [
    F
  ]);
  function el(B) {
    const Y = B ? (window.innerWidth - Qe) / window.innerWidth : 1, X = B ? -Qe : 0;
    ae.current && window.clearTimeout(ae.current), te(U.current, {
      transition: `transform ${Z.DURATION}s cubic-bezier(${Z.EASE.join(",")})`,
      transform: ee(b) ? `scale(${Y}) translate3d(0, ${X}px, 0)` : `scale(${Y}) translate3d(${X}px, 0, 0)`
    }), !B && U.current && (ae.current = setTimeout(() => {
      const K = an(U.current, b);
      te(U.current, {
        transition: "none",
        transform: ee(b) ? `translate3d(0, ${K}px, 0)` : `translate3d(${K}px, 0, 0)`
      });
    }, 500));
  }
  function tl(B, Y) {
    if (Y < 0)
      return;
    const X = (window.innerWidth - Qe) / window.innerWidth, K = X + Y * (1 - X), J = -Qe + Y * Qe;
    te(U.current, {
      transform: ee(b) ? `scale(${K}) translate3d(0, ${J}px, 0)` : `scale(${K}) translate3d(${J}px, 0, 0)`,
      transition: "none"
    });
  }
  function nl(B, Y) {
    const X = ee(b) ? window.innerHeight : window.innerWidth, K = Y ? (X - Qe) / X : 1, J = Y ? -Qe : 0;
    Y && te(U.current, {
      transition: `transform ${Z.DURATION}s cubic-bezier(${Z.EASE.join(",")})`,
      transform: ee(b) ? `scale(${K}) translate3d(0, ${J}px, 0)` : `scale(${K}) translate3d(${J}px, 0, 0)`
    });
  }
  return T.useEffect(() => {
    g || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    g
  ]), /* @__PURE__ */ T.createElement(eh, {
    defaultOpen: S,
    onOpenChange: (B) => {
      !d && !B || (B ? _(!0) : Ct(!0), k(B));
    },
    open: F
  }, /* @__PURE__ */ T.createElement(nc.Provider, {
    value: {
      activeSnapPoint: ot,
      snapPoints: i,
      setActiveSnapPoint: yo,
      drawerRef: U,
      overlayRef: ie,
      onOpenChange: t,
      onPress: qc,
      onRelease: Jc,
      onDrag: Zc,
      dismissible: d,
      shouldAnimate: wt,
      handleOnly: f,
      isOpen: F,
      isDragging: M,
      shouldFade: bo,
      closeDrawer: Ct,
      onNestedDrag: tl,
      onNestedOpenChange: el,
      onNestedRelease: nl,
      keyboardIsOpen: De,
      modal: g,
      snapPointsOffset: Et,
      activeSnapPointIndex: it,
      direction: b,
      shouldScaleBackground: s,
      setBackgroundColorOnScale: a,
      noBodyStyles: x,
      container: $,
      autoFocus: D
    }
  }, n));
}
const fc = /* @__PURE__ */ T.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: i, isOpen: s, modal: a, shouldAnimate: u } = bt(), l = ic(t, n), d = r && r.length > 0;
  if (!a)
    return null;
  const f = T.useCallback((p) => o(p), [
    o
  ]);
  return /* @__PURE__ */ T.createElement(rh, {
    onMouseUp: f,
    ref: l,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && d ? "true" : "false",
    "data-vaul-snap-points-overlay": s && i ? "true" : "false",
    "data-vaul-animate": u != null && u.current ? "true" : "false",
    ...e
  });
});
fc.displayName = "Drawer.Overlay";
const pc = /* @__PURE__ */ T.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: i, onPress: s, onRelease: a, onDrag: u, keyboardIsOpen: l, snapPointsOffset: d, activeSnapPointIndex: f, modal: p, isOpen: v, direction: w, snapPoints: h, container: g, handleOnly: y, shouldAnimate: E, autoFocus: x } = bt(), [b, S] = T.useState(!1), N = ic(o, i), C = T.useRef(null), R = T.useRef(null), O = T.useRef(!1), I = h && h.length > 0;
  Ah();
  const $ = (A, P, F = 0) => {
    if (O.current)
      return !0;
    const k = Math.abs(A.y), V = Math.abs(A.x), _ = V > k, M = [
      "bottom",
      "right"
    ].includes(P) ? 1 : -1;
    if (P === "left" || P === "right") {
      if (!(A.x * M < 0) && V >= 0 && V <= F)
        return _;
    } else if (!(A.y * M < 0) && k >= 0 && k <= F)
      return !_;
    return O.current = !0, !0;
  };
  T.useEffect(() => {
    I && window.requestAnimationFrame(() => {
      S(!0);
    });
  }, []);
  function D(A) {
    C.current = null, O.current = !1, a(A);
  }
  return /* @__PURE__ */ T.createElement(oh, {
    "data-vaul-drawer-direction": w,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": b ? "true" : "false",
    "data-vaul-snap-points": v && I ? "true" : "false",
    "data-vaul-custom-container": g ? "true" : "false",
    "data-vaul-animate": E != null && E.current ? "true" : "false",
    ...r,
    ref: N,
    style: d && d.length > 0 ? {
      "--snap-point-height": `${d[f ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (A) => {
      y || (r.onPointerDown == null || r.onPointerDown.call(r, A), C.current = {
        x: A.pageX,
        y: A.pageY
      }, s(A));
    },
    onOpenAutoFocus: (A) => {
      n == null || n(A), x || A.preventDefault();
    },
    onPointerDownOutside: (A) => {
      if (e == null || e(A), !p || A.defaultPrevented) {
        A.preventDefault();
        return;
      }
      l.current && (l.current = !1);
    },
    onFocusOutside: (A) => {
      if (!p) {
        A.preventDefault();
        return;
      }
    },
    onPointerMove: (A) => {
      if (R.current = A, y || (r.onPointerMove == null || r.onPointerMove.call(r, A), !C.current))
        return;
      const P = A.pageY - C.current.y, F = A.pageX - C.current.x, k = A.pointerType === "touch" ? 10 : 2;
      $({
        x: F,
        y: P
      }, w, k) ? u(A) : (Math.abs(F) > k || Math.abs(P) > k) && (C.current = null);
    },
    onPointerUp: (A) => {
      r.onPointerUp == null || r.onPointerUp.call(r, A), C.current = null, O.current = !1, a(A);
    },
    onPointerOut: (A) => {
      r.onPointerOut == null || r.onPointerOut.call(r, A), D(R.current);
    },
    onContextMenu: (A) => {
      r.onContextMenu == null || r.onContextMenu.call(r, A), R.current && D(R.current);
    }
  });
});
pc.displayName = "Drawer.Content";
const Oh = 250, Dh = 120, mc = /* @__PURE__ */ T.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: i, snapPoints: s, activeSnapPoint: a, setActiveSnapPoint: u, dismissible: l, handleOnly: d, isOpen: f, onPress: p, onDrag: v } = bt(), w = T.useRef(null), h = T.useRef(!1);
  function g() {
    if (h.current) {
      x();
      return;
    }
    window.setTimeout(() => {
      y();
    }, Dh);
  }
  function y() {
    if (i || e || h.current) {
      x();
      return;
    }
    if (x(), !s || s.length === 0) {
      l || o();
      return;
    }
    if (a === s[s.length - 1] && l) {
      o();
      return;
    }
    const S = s.findIndex((C) => C === a);
    if (S === -1)
      return;
    const N = s[S + 1];
    u(N);
  }
  function E() {
    w.current = window.setTimeout(() => {
      h.current = !0;
    }, Oh);
  }
  function x() {
    w.current && window.clearTimeout(w.current), h.current = !1;
  }
  return /* @__PURE__ */ T.createElement("div", {
    onClick: g,
    onPointerCancel: x,
    onPointerDown: (b) => {
      d && p(b), E();
    },
    onPointerMove: (b) => {
      d && v(b);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": f ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ T.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
mc.displayName = "Drawer.Handle";
function Ih({ onDrag: e, onOpenChange: t, open: n, ...r }) {
  const { onNestedDrag: o, onNestedOpenChange: i, onNestedRelease: s } = bt();
  if (!o)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ T.createElement(dc, {
    nested: !0,
    open: n,
    onClose: () => {
      i(!1);
    },
    onDrag: (a, u) => {
      o(a, u), e == null || e(a, u);
    },
    onOpenChange: (a) => {
      a && i(a), t == null || t(a);
    },
    onRelease: s,
    ...r
  });
}
function _h(e) {
  const t = bt(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ T.createElement(nh, {
    container: n,
    ...r
  });
}
const sn = {
  Root: dc,
  NestedRoot: Ih,
  Content: pc,
  Overlay: fc,
  Trigger: th,
  Portal: _h,
  Handle: mc,
  Close: sh,
  Title: ih,
  Description: ah
};
// @__NO_SIDE_EFFECTS__
function xr(e) {
  const t = /* @__PURE__ */ kh(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(Lh);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ m(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ m(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function kh(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = Bh(o), a = Fh(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? tt(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var $h = Symbol("radix.slottable");
function Lh(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === $h;
}
function Fh(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      const u = i(...a);
      return o(...a), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Bh(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Wh(e) {
  const t = e + "CollectionProvider", [n, r] = Xe(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: g, children: y } = h, E = T.useRef(null), x = T.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ m(o, { scope: g, itemMap: x, collectionRef: E, children: y });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", u = /* @__PURE__ */ xr(a), l = T.forwardRef(
    (h, g) => {
      const { scope: y, children: E } = h, x = i(a, y), b = Q(g, x.collectionRef);
      return /* @__PURE__ */ m(u, { ref: b, children: E });
    }
  );
  l.displayName = a;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", p = /* @__PURE__ */ xr(d), v = T.forwardRef(
    (h, g) => {
      const { scope: y, children: E, ...x } = h, b = T.useRef(null), S = Q(g, b), N = i(d, y);
      return T.useEffect(() => (N.itemMap.set(b, { ref: b, ...x }), () => void N.itemMap.delete(b))), /* @__PURE__ */ m(p, { [f]: "", ref: S, children: E });
    }
  );
  v.displayName = d;
  function w(h) {
    const g = i(e + "CollectionConsumer", h);
    return T.useCallback(() => {
      const E = g.collectionRef.current;
      if (!E)
        return [];
      const x = Array.from(E.querySelectorAll(`[${f}]`));
      return Array.from(g.itemMap.values()).sort(
        (N, C) => x.indexOf(N.ref.current) - x.indexOf(C.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: s, Slot: l, ItemSlot: v },
    w,
    r
  ];
}
var Vh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Me = Vh.reduce((e, t) => {
  const n = /* @__PURE__ */ xr(`Primitive.${t}`), r = c.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(u, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function hc(e, t) {
  e && Ft.flushSync(() => e.dispatchEvent(t));
}
var Uh = "DismissableLayer", Er = "dismissableLayer.update", zh = "dismissableLayer.pointerDownOutside", Hh = "dismissableLayer.focusOutside", fi, gc = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), vc = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...u
    } = e, l = c.useContext(gc), [d, f] = c.useState(null), p = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = c.useState({}), w = Q(t, (C) => f(C)), h = Array.from(l.layers), [g] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = h.indexOf(g), E = d ? h.indexOf(d) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, b = E >= y, S = Kh((C) => {
      const R = C.target, O = [...l.branches].some((I) => I.contains(R));
      !b || O || (o == null || o(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, p), N = Gh((C) => {
      const R = C.target;
      [...l.branches].some((I) => I.contains(R)) || (i == null || i(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, p);
    return Wi((C) => {
      E === l.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && a && (C.preventDefault(), a()));
    }, p), c.useEffect(() => {
      if (d)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (fi = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), pi(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = fi);
        };
    }, [d, p, n, l]), c.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), pi());
    }, [d, l]), c.useEffect(() => {
      const C = () => v({});
      return document.addEventListener(Er, C), () => document.removeEventListener(Er, C);
    }, []), /* @__PURE__ */ m(
      Me.div,
      {
        ...u,
        ref: w,
        style: {
          pointerEvents: x ? b ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: L(e.onFocusCapture, N.onFocusCapture),
        onBlurCapture: L(e.onBlurCapture, N.onBlurCapture),
        onPointerDownCapture: L(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
vc.displayName = Uh;
var jh = "DismissableLayerBranch", yc = c.forwardRef((e, t) => {
  const n = c.useContext(gc), r = c.useRef(null), o = Q(t, r);
  return c.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ m(Me.div, { ...e, ref: o });
});
yc.displayName = jh;
function Kh(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let u = function() {
          bc(
            zh,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Gh(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && bc(Hh, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function pi() {
  const e = new CustomEvent(Er);
  document.dispatchEvent(e);
}
function bc(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? hc(o, i) : o.dispatchEvent(i);
}
var Yh = vc, Xh = yc, qh = "Portal", wc = c.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = c.useState(!1);
  Te(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? kr.createPortal(/* @__PURE__ */ m(Me.div, { ...r, ref: t }), s) : null;
});
wc.displayName = qh;
var Zh = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Qh = "VisuallyHidden", so = c.forwardRef(
  (e, t) => /* @__PURE__ */ m(
    Me.span,
    {
      ...e,
      ref: t,
      style: { ...Zh, ...e.style }
    }
  )
);
so.displayName = Qh;
var co = "ToastProvider", [lo, Jh, eg] = Wh("Toast"), [xc, wv] = Xe("Toast", [eg]), [tg, On] = xc(co), Ec = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: i = 50,
    children: s
  } = e, [a, u] = c.useState(null), [l, d] = c.useState(0), f = c.useRef(!1), p = c.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${co}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ m(lo.Provider, { scope: t, children: /* @__PURE__ */ m(
    tg,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: l,
      viewport: a,
      onViewportChange: u,
      onToastAdd: c.useCallback(() => d((v) => v + 1), []),
      onToastRemove: c.useCallback(() => d((v) => v - 1), []),
      isFocusedToastEscapeKeyDownRef: f,
      isClosePausedRef: p,
      children: s
    }
  ) });
};
Ec.displayName = co;
var Cc = "ToastViewport", ng = ["F8"], Cr = "toast.viewportPause", Sr = "toast.viewportResume", Sc = c.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = ng,
      label: o = "Notifications ({hotkey})",
      ...i
    } = e, s = On(Cc, n), a = Jh(n), u = c.useRef(null), l = c.useRef(null), d = c.useRef(null), f = c.useRef(null), p = Q(t, f, s.onViewportChange), v = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), w = s.toastCount > 0;
    c.useEffect(() => {
      const g = (y) => {
        var x;
        r.length !== 0 && r.every((b) => y[b] || y.code === b) && ((x = f.current) == null || x.focus());
      };
      return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
    }, [r]), c.useEffect(() => {
      const g = u.current, y = f.current;
      if (w && g && y) {
        const E = () => {
          if (!s.isClosePausedRef.current) {
            const N = new CustomEvent(Cr);
            y.dispatchEvent(N), s.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (s.isClosePausedRef.current) {
            const N = new CustomEvent(Sr);
            y.dispatchEvent(N), s.isClosePausedRef.current = !1;
          }
        }, b = (N) => {
          !g.contains(N.relatedTarget) && x();
        }, S = () => {
          g.contains(document.activeElement) || x();
        };
        return g.addEventListener("focusin", E), g.addEventListener("focusout", b), g.addEventListener("pointermove", E), g.addEventListener("pointerleave", S), window.addEventListener("blur", E), window.addEventListener("focus", x), () => {
          g.removeEventListener("focusin", E), g.removeEventListener("focusout", b), g.removeEventListener("pointermove", E), g.removeEventListener("pointerleave", S), window.removeEventListener("blur", E), window.removeEventListener("focus", x);
        };
      }
    }, [w, s.isClosePausedRef]);
    const h = c.useCallback(
      ({ tabbingDirection: g }) => {
        const E = a().map((x) => {
          const b = x.ref.current, S = [b, ...hg(b)];
          return g === "forwards" ? S : S.reverse();
        });
        return (g === "forwards" ? E.reverse() : E).flat();
      },
      [a]
    );
    return c.useEffect(() => {
      const g = f.current;
      if (g) {
        const y = (E) => {
          var S, N, C;
          const x = E.altKey || E.ctrlKey || E.metaKey;
          if (E.key === "Tab" && !x) {
            const R = document.activeElement, O = E.shiftKey;
            if (E.target === g && O) {
              (S = l.current) == null || S.focus();
              return;
            }
            const D = h({ tabbingDirection: O ? "backwards" : "forwards" }), A = D.findIndex((P) => P === R);
            er(D.slice(A + 1)) ? E.preventDefault() : O ? (N = l.current) == null || N.focus() : (C = d.current) == null || C.focus();
          }
        };
        return g.addEventListener("keydown", y), () => g.removeEventListener("keydown", y);
      }
    }, [a, h]), /* @__PURE__ */ z(
      Xh,
      {
        ref: u,
        role: "region",
        "aria-label": o.replace("{hotkey}", v),
        tabIndex: -1,
        style: { pointerEvents: w ? void 0 : "none" },
        children: [
          w && /* @__PURE__ */ m(
            Rr,
            {
              ref: l,
              onFocusFromOutsideViewport: () => {
                const g = h({
                  tabbingDirection: "forwards"
                });
                er(g);
              }
            }
          ),
          /* @__PURE__ */ m(lo.Slot, { scope: n, children: /* @__PURE__ */ m(Me.ol, { tabIndex: -1, ...i, ref: p }) }),
          w && /* @__PURE__ */ m(
            Rr,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const g = h({
                  tabbingDirection: "backwards"
                });
                er(g);
              }
            }
          )
        ]
      }
    );
  }
);
Sc.displayName = Cc;
var Rc = "ToastFocusProxy", Rr = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, i = On(Rc, n);
    return /* @__PURE__ */ m(
      so,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (s) => {
          var l;
          const a = s.relatedTarget;
          !((l = i.viewport) != null && l.contains(a)) && r();
        }
      }
    );
  }
);
Rr.displayName = Rc;
var Kt = "Toast", rg = "toast.swipeStart", og = "toast.swipeMove", ig = "toast.swipeCancel", ag = "toast.swipeEnd", Tc = c.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: i, ...s } = e, [a, u] = Bt({
      prop: r,
      defaultProp: o ?? !0,
      onChange: i,
      caller: Kt
    });
    return /* @__PURE__ */ m(nt, { present: n || a, children: /* @__PURE__ */ m(
      lg,
      {
        open: a,
        ...s,
        ref: t,
        onClose: () => u(!1),
        onPause: se(e.onPause),
        onResume: se(e.onResume),
        onSwipeStart: L(e.onSwipeStart, (l) => {
          l.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: L(e.onSwipeMove, (l) => {
          const { x: d, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: L(e.onSwipeCancel, (l) => {
          l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: L(e.onSwipeEnd, (l) => {
          const { x: d, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), u(!1);
        })
      }
    ) });
  }
);
Tc.displayName = Kt;
var [sg, cg] = xc(Kt, {
  onClose() {
  }
}), lg = c.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: i,
      onClose: s,
      onEscapeKeyDown: a,
      onPause: u,
      onResume: l,
      onSwipeStart: d,
      onSwipeMove: f,
      onSwipeCancel: p,
      onSwipeEnd: v,
      ...w
    } = e, h = On(Kt, n), [g, y] = c.useState(null), E = Q(t, (P) => y(P)), x = c.useRef(null), b = c.useRef(null), S = o || h.duration, N = c.useRef(0), C = c.useRef(S), R = c.useRef(0), { onToastAdd: O, onToastRemove: I } = h, $ = se(() => {
      var F;
      (g == null ? void 0 : g.contains(document.activeElement)) && ((F = h.viewport) == null || F.focus()), s();
    }), D = c.useCallback(
      (P) => {
        !P || P === 1 / 0 || (window.clearTimeout(R.current), N.current = (/* @__PURE__ */ new Date()).getTime(), R.current = window.setTimeout($, P));
      },
      [$]
    );
    c.useEffect(() => {
      const P = h.viewport;
      if (P) {
        const F = () => {
          D(C.current), l == null || l();
        }, k = () => {
          const V = (/* @__PURE__ */ new Date()).getTime() - N.current;
          C.current = C.current - V, window.clearTimeout(R.current), u == null || u();
        };
        return P.addEventListener(Cr, k), P.addEventListener(Sr, F), () => {
          P.removeEventListener(Cr, k), P.removeEventListener(Sr, F);
        };
      }
    }, [h.viewport, S, u, l, D]), c.useEffect(() => {
      i && !h.isClosePausedRef.current && D(S);
    }, [i, S, h.isClosePausedRef, D]), c.useEffect(() => (O(), () => I()), [O, I]);
    const A = c.useMemo(() => g ? _c(g) : null, [g]);
    return h.viewport ? /* @__PURE__ */ z(pt, { children: [
      A && /* @__PURE__ */ m(
        ug,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: A
        }
      ),
      /* @__PURE__ */ m(sg, { scope: n, onClose: $, children: Ft.createPortal(
        /* @__PURE__ */ m(lo.ItemSlot, { scope: n, children: /* @__PURE__ */ m(
          Yh,
          {
            asChild: !0,
            onEscapeKeyDown: L(a, () => {
              h.isFocusedToastEscapeKeyDownRef.current || $(), h.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ m(
              Me.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": i ? "open" : "closed",
                "data-swipe-direction": h.swipeDirection,
                ...w,
                ref: E,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: L(e.onKeyDown, (P) => {
                  P.key === "Escape" && (a == null || a(P.nativeEvent), P.nativeEvent.defaultPrevented || (h.isFocusedToastEscapeKeyDownRef.current = !0, $()));
                }),
                onPointerDown: L(e.onPointerDown, (P) => {
                  P.button === 0 && (x.current = { x: P.clientX, y: P.clientY });
                }),
                onPointerMove: L(e.onPointerMove, (P) => {
                  if (!x.current)
                    return;
                  const F = P.clientX - x.current.x, k = P.clientY - x.current.y, V = !!b.current, _ = ["left", "right"].includes(h.swipeDirection), M = ["left", "up"].includes(h.swipeDirection) ? Math.min : Math.max, j = _ ? M(0, F) : 0, G = _ ? 0 : M(0, k), oe = P.pointerType === "touch" ? 10 : 2, ie = { x: j, y: G }, fe = { originalEvent: P, delta: ie };
                  V ? (b.current = ie, cn(og, f, fe, {
                    discrete: !1
                  })) : mi(ie, h.swipeDirection, oe) ? (b.current = ie, cn(rg, d, fe, {
                    discrete: !1
                  }), P.target.setPointerCapture(P.pointerId)) : (Math.abs(F) > oe || Math.abs(k) > oe) && (x.current = null);
                }),
                onPointerUp: L(e.onPointerUp, (P) => {
                  const F = b.current, k = P.target;
                  if (k.hasPointerCapture(P.pointerId) && k.releasePointerCapture(P.pointerId), b.current = null, x.current = null, F) {
                    const V = P.currentTarget, _ = { originalEvent: P, delta: F };
                    mi(F, h.swipeDirection, h.swipeThreshold) ? cn(ag, v, _, {
                      discrete: !0
                    }) : cn(
                      ig,
                      p,
                      _,
                      {
                        discrete: !0
                      }
                    ), V.addEventListener("click", (M) => M.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        h.viewport
      ) })
    ] }) : null;
  }
), ug = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = On(Kt, t), [i, s] = c.useState(!1), [a, u] = c.useState(!1);
  return pg(() => s(!0)), c.useEffect(() => {
    const l = window.setTimeout(() => u(!0), 1e3);
    return () => window.clearTimeout(l);
  }, []), a ? null : /* @__PURE__ */ m(wc, { asChild: !0, children: /* @__PURE__ */ m(so, { ...r, children: i && /* @__PURE__ */ z(pt, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, dg = "ToastTitle", Nc = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ m(Me.div, { ...r, ref: t });
  }
);
Nc.displayName = dg;
var fg = "ToastDescription", Pc = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ m(Me.div, { ...r, ref: t });
  }
);
Pc.displayName = fg;
var Ac = "ToastAction", Mc = c.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ m(Ic, { altText: n, asChild: !0, children: /* @__PURE__ */ m(Dc, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Ac}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
Mc.displayName = Ac;
var Oc = "ToastClose", Dc = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = cg(Oc, n);
    return /* @__PURE__ */ m(Ic, { asChild: !0, children: /* @__PURE__ */ m(
      Me.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: L(e.onClick, o.onClose)
      }
    ) });
  }
);
Dc.displayName = Oc;
var Ic = c.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ m(
    Me.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function _c(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), mg(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", i = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const s = r.dataset.radixToastAnnounceAlt;
          s && t.push(s);
        } else
          t.push(..._c(r));
    }
  }), t;
}
function cn(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, i = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? hc(o, i) : o.dispatchEvent(i);
}
var mi = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), i = r > o;
  return t === "left" || t === "right" ? i && r > n : !i && o > n;
};
function pg(e = () => {
}) {
  const t = se(e);
  Te(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function mg(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function hg(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function er(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var gg = Ec, vg = Sc, yg = Tc, bg = Nc, wg = Pc, xg = Mc;
const kc = gg, uo = c.forwardRef((e, t) => /* @__PURE__ */ m(yg, { ref: t, ...e }));
uo.displayName = "PrimitiveToastRootToastRoot";
const fo = c.forwardRef((e, t) => /* @__PURE__ */ m(vg, { ref: t, ...e }));
fo.displayName = "PrimitiveToastViewport";
const $c = c.forwardRef((e, t) => /* @__PURE__ */ m(xg, { ref: t, ...e }));
$c.displayName = "PrimitiveToastAction";
const po = c.forwardRef((e, t) => /* @__PURE__ */ m(bg, { ref: t, ...e }));
po.displayName = "PrimitiveToastTitle";
const mo = c.forwardRef((e, t) => /* @__PURE__ */ m(wg, { ref: t, ...e }));
mo.displayName = "PrimitiveToastDescription";
const Lc = ({ children: e, className: t }) => /* @__PURE__ */ z("div", { className: W("flex items-center gap-1", t), children: [
  /* @__PURE__ */ m(_e, { name: "info", size: 16, color: "#C6CACE", filled: !0 }),
  /* @__PURE__ */ m("span", { className: "typography-ui-13r text-gray-400", children: e })
] }), Eg = T.forwardRef(
  ({
    title: e,
    description: t,
    children: n,
    informationText: r,
    className: o,
    closeOnOverlayClick: i = !0,
    closeOnEscape: s = !0,
    ...a
  }, u) => {
    const { open: l, onOpenChange: d, contentId: f } = xi(), p = At(null), v = At(null), [w, h] = Pe(!1), g = At(null);
    T.useImperativeHandle(u, () => v.current, []), be(() => (l ? (g.current && (clearTimeout(g.current), g.current = null), h(!0)) : w && (g.current && clearTimeout(g.current), g.current = setTimeout(() => {
      h(!1), g.current = null;
    }, 250)), () => {
      g.current && (clearTimeout(g.current), g.current = null);
    }), [l, w]), be(() => {
      if (!s || !l)
        return;
      const x = (b) => {
        b.key === "Escape" && d(!1);
      };
      return document.addEventListener("keydown", x), () => document.removeEventListener("keydown", x);
    }, [s, l, d]), be(() => {
      var S;
      if (!l)
        return;
      const x = document.activeElement, b = (S = v.current) == null ? void 0 : S.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      return b && b.length > 0 && b[0].focus(), () => {
        x && x.focus();
      };
    }, [l]);
    const y = (x) => {
      i && x.target === p.current && d(!1);
    };
    if (!w)
      return null;
    const E = /* @__PURE__ */ m(
      "div",
      {
        ref: p,
        className: W(
          "fixed inset-0 z-50 flex items-end justify-center bg-black/50 p-4",
          l ? "animate-fade-in" : "animate-fade-out"
        ),
        onClick: y,
        children: /* @__PURE__ */ z(
          "div",
          {
            ref: v,
            id: f,
            className: W(
              "flex min-w-[336px] max-w-md flex-col gap-4 rounded-2xl bg-white px-3 py-6",
              l ? "animate-slide-up" : "animate-slide-down",
              o
            ),
            ...a,
            children: [
              /* @__PURE__ */ z("div", { className: "flex flex-col gap-2 px-3", children: [
                /* @__PURE__ */ m("h2", { className: "typography-ui-20sb text-gray-900", children: e }),
                t && /* @__PURE__ */ m("p", { className: "typography-ui-15r text-gray-600", children: t })
              ] }),
              /* @__PURE__ */ m("div", { className: "flex flex-col", children: n }),
              r && /* @__PURE__ */ m("div", { className: "px-3", children: /* @__PURE__ */ m(Lc, { children: r }) })
            ]
          }
        )
      }
    );
    return $r(E, document.body);
  }
);
Eg.displayName = "ActionSheetContent";
const Fc = c.forwardRef(
  ({ label: e, description: t, showNew: n = !1, className: r, ...o }, i) => /* @__PURE__ */ z("div", { ref: i, className: W("flex flex-col gap-1", r), ...o, children: [
    /* @__PURE__ */ z("div", { className: "flex flex-row items-center gap-1", children: [
      /* @__PURE__ */ m("span", { className: "typography-ui-17m text-gray-600", children: e }),
      n && /* @__PURE__ */ m("div", { className: "flex h-[18px] w-[18px] items-center justify-center rounded-full bg-red-600", children: /* @__PURE__ */ m("span", { className: "typography-ui-12sb !text-white", children: "N" }) })
    ] }),
    t && /* @__PURE__ */ m("span", { className: "typography-ui-13r text-start text-gray-400", children: t })
  ] })
);
Fc.displayName = "ActionSheetItemLabel";
const Cg = c.forwardRef(
  ({ label: e, description: t, showNew: n = !1, selected: r = !1, onPress: o, className: i, onClick: s, ...a }, u) => {
    const l = (d) => {
      o == null || o(), s == null || s(d);
    };
    return /* @__PURE__ */ z(
      "button",
      {
        ref: u,
        className: W(
          // 기본 스타일
          "flex flex-row items-center justify-center gap-2 rounded-lg px-3 py-4",
          "w-full transition-colors duration-200",
          // 호버/액티브 상태
          "hover:bg-gray-30 active:bg-gray-30",
          // 포커스 상태
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500",
          i
        ),
        onClick: l,
        ...a,
        children: [
          /* @__PURE__ */ m("div", { className: "flex-1", children: /* @__PURE__ */ m(
            Fc,
            {
              label: e,
              description: t,
              showNew: n,
              className: W(
                // 선택 상태에 따른 텍스트 색상 오버라이드
                r && "[&_span:first-child]:text-gray-900"
              )
            }
          ) }),
          r && /* @__PURE__ */ m(tm, { className: "flex-shrink-0" })
        ]
      }
    );
  }
);
Cg.displayName = "ActionSheetItem";
const hi = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, gi = Ci, Dn = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return gi(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, s = Object.keys(o).map((l) => {
    const d = n == null ? void 0 : n[l], f = i == null ? void 0 : i[l];
    if (d === null)
      return null;
    const p = hi(d) || hi(f);
    return o[l][p];
  }), a = n && Object.entries(n).reduce((l, d) => {
    let [f, p] = d;
    return p === void 0 || (l[f] = p), l;
  }, {}), u = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, d) => {
    let { class: f, className: p, ...v } = d;
    return Object.entries(v).every((w) => {
      let [h, g] = w;
      return Array.isArray(g) ? g.includes({
        ...i,
        ...a
      }[h]) : {
        ...i,
        ...a
      }[h] === g;
    }) ? [
      ...l,
      f,
      p
    ] : l;
  }, []);
  return gi(e, s, u, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Sg = Dn(
  "inline-flex items-center justify-center whitespace-nowrap font-pretendard transition-colors focus-visible:outline-none disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      size: {
        s: "typography-ui-13m h-8 gap-1 rounded-[8px] px-2",
        m: "typography-ui-15sb h-10 gap-1 rounded-[8px] px-3",
        l: "typography-ui-17sb h-12 gap-2 rounded-[12px] px-4",
        xl: "typography-ui-17sb h-14 gap-2 rounded-[12px] px-5"
      },
      buttonColor: {
        primary: "",
        red: "",
        gray: "",
        primaryLight: ""
      },
      buttonStyle: {
        contained: "",
        outlined: ""
      }
    },
    defaultVariants: {
      size: "m",
      buttonColor: "primary",
      buttonStyle: "contained"
    },
    compoundVariants: [
      // Primary Contained
      {
        buttonColor: "primary",
        buttonStyle: "contained",
        className: "bg-primary-600 text-white hover:bg-primary-700 active:scale-[0.98] active:bg-primary-800 disabled:bg-gray-100 disabled:text-white"
      },
      // Primary Outlined
      {
        buttonColor: "primary",
        buttonStyle: "outlined",
        className: "border border-primary-500 border-solid bg-white text-primary-700 hover:bg-primary-100 active:scale-[0.98] active:bg-primary-200 disabled:border-gray-100 disabled:bg-gray-100 disabled:text-white"
      },
      // Gray Contained
      {
        buttonColor: "gray",
        buttonStyle: "contained",
        className: "bg-gray-700 text-white hover:bg-gray-800 active:scale-[0.98] active:bg-gray-900 disabled:bg-gray-100 disabled:text-white"
      },
      // Gray Outlined
      {
        buttonColor: "gray",
        buttonStyle: "outlined",
        className: "border border-gray-100 border-solid bg-white text-gray-600 hover:bg-gray-30 active:scale-[0.98] active:bg-gray-50 disabled:border-gray-100 disabled:bg-gray-100 disabled:text-white"
      },
      // Red Contained
      {
        buttonColor: "red",
        buttonStyle: "contained",
        className: "bg-red-600 text-white hover:bg-red-700 active:scale-[0.98] active:bg-red-800 disabled:bg-gray-100 disabled:text-white"
      },
      // PrimaryLight Contained
      {
        buttonColor: "primaryLight",
        buttonStyle: "contained",
        className: "bg-primary-100 text-primary-700 hover:bg-primary-200 active:scale-[0.98] active:bg-primary-300 disabled:bg-gray-100 disabled:text-white"
      }
    ]
  }
), fn = c.forwardRef(
  ({ className: e, size: t, buttonColor: n, buttonStyle: r, asChild: o = !1, ...i }, s) => /* @__PURE__ */ m(o ? Mi : "button", { className: W(Sg({ size: t, buttonColor: n, buttonStyle: r, className: e })), ref: s, ...i })
);
fn.displayName = "Button";
const Bc = T.forwardRef(
  ({ state: e = "enabled", autoStateChange: t = !0, containerClassName: n, className: r, disabled: o, onChange: i, value: s, ...a }, u) => {
    const l = () => o ? "disabled" : s && s.toString().trim() !== "" ? "typed" : e, [d, f] = Pe(l()), p = At(null), v = u || p;
    be(() => {
      o ? f("disabled") : e !== d && !t && f(e);
    }, [e, o, t, d]), be(() => {
      if (!o && t) {
        const x = s && s.toString().trim() !== "";
        x && (d === "enabled" || d === "focus") ? f("typed") : !x && d === "typed" && f("enabled");
      }
    }, [s, o, t, d]);
    const w = (x) => {
      var b;
      o || (t && f(s ? "typed" : "focus"), (b = a.onFocus) == null || b.call(a, x));
    }, h = (x) => {
      var b;
      o || (t && f(s ? "typed" : "enabled"), (b = a.onBlur) == null || b.call(a, x));
    }, g = (x) => {
      o || (t && f(x.target.value ? "typing" : "focus"), i == null || i(x));
    }, y = W(
      "relative flex w-full rounded-lg bg-gray-30 px-[16px] py-[13px] min-h-[120px] max-h-[240px]",
      {
        "cursor-not-allowed": d === "disabled"
      },
      n
    ), E = W(
      "typography-ui-17m placeholder:text-gray-300 w-full p-0 resize-none bg-transparent border-none outline-none caret-primary-700",
      {
        "text-gray-100": d === "disabled",
        "text-gray-300": d === "enabled" || d === "focus",
        "text-gray-700": d === "typing" || d === "typed"
      },
      r
    );
    return /* @__PURE__ */ m("div", { className: y, children: /* @__PURE__ */ m("div", { className: "relative flex w-full gap-0.5", children: /* @__PURE__ */ m(
      "textarea",
      {
        ref: v,
        className: E,
        disabled: o || d === "disabled",
        onChange: g,
        onFocus: w,
        onBlur: h,
        value: s,
        ...a
      }
    ) }) });
  }
);
Bc.displayName = "AreaContainer";
function Rg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Wc = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", s = 0; s < arguments.length; s++) {
        var a = arguments[s];
        a && (i = o(i, r(a)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var s = "";
      for (var a in i)
        t.call(i, a) && i[a] && (s = o(s, a));
      return s;
    }
    function o(i, s) {
      return s ? i ? i + " " + s : i + s : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Wc);
var Tg = Wc.exports;
const Ng = /* @__PURE__ */ Rg(Tg), ho = ({
  state: e = "default",
  text: t,
  characterCount: n,
  maxLength: r = 50,
  showCharacterCounter: o = !1,
  className: i
}) => /* @__PURE__ */ z("div", { className: "flex w-full items-center justify-between", children: [
  /* @__PURE__ */ m(
    "div",
    {
      className: Ng(
        "typography-ui-13r w-full rounded-md border-none",
        {
          "text-gray-400": e === "default",
          "text-red-700": e === "error"
        },
        i
      ),
      children: t
    }
  ),
  o && /* @__PURE__ */ m("div", { className: "mt-1 flex justify-end", children: /* @__PURE__ */ z("span", { className: "typography-ui-13r text-gray-500", children: [
    /* @__PURE__ */ m("span", { className: "text-gray-500", children: n }),
    /* @__PURE__ */ z("span", { className: "text-gray-400", children: [
      "/",
      r
    ] })
  ] }) })
] }), Pg = ne(
  ({
    className: e,
    helpTextArea: t,
    maxLength: n,
    showCharacterCount: r = !1,
    state: o = "enabled",
    autoStateChange: i = !0,
    containerClassName: s,
    disabled: a,
    value: u,
    onChange: l,
    ...d
  }, f) => {
    var y;
    const [p, v] = Pe(((y = d.defaultValue) == null ? void 0 : y.toString().length) || (u == null ? void 0 : u.toString().length) || 0);
    be(() => {
      u !== void 0 && v(u.toString().length);
    }, [u]);
    const w = (E) => {
      v(E.target.value.length), l == null || l(E);
    }, h = W("flex w-full flex-col gap-[8px]", s), g = a || o === "disabled" ? "default" : o === "error" ? "error" : "default";
    return /* @__PURE__ */ z("div", { className: h, children: [
      /* @__PURE__ */ m(
        Bc,
        {
          ref: f,
          className: W("min-h-[80px]", e),
          state: o,
          autoStateChange: i,
          disabled: a,
          value: u,
          onChange: w,
          maxLength: n,
          ...d
        }
      ),
      (t || r) && /* @__PURE__ */ m("div", { className: "flex w-full items-center justify-between", children: /* @__PURE__ */ m(
        ho,
        {
          state: g,
          text: t || "",
          showCharacterCounter: r,
          characterCount: p,
          maxLength: n,
          className: "border-0 p-0"
        }
      ) })
    ] });
  }
);
Pg.displayName = "TextArea";
const lt = {
  wrapper: "relative w-full",
  inputWrapper: "flex items-center w-full h-[50px] px-4 py-[13px] rounded-[8px] bg-gray-30",
  input: "typography-ui-17m flex-1 h-full w-full p-0 border-none bg-transparent text-gray-700 placeholder:text-gray-300 outline-none focus:outline-none disabled:cursor-not-allowed caret-primary-700 [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&]:appearance-none",
  clearButton: "cursor-pointer text-gray-600",
  validationIcon: "cursor-default",
  iconContainer: "flex items-center gap-[4px] pl-[8px]"
}, Vc = ne(
  ({
    className: e,
    value: t,
    onChange: n,
    onValueChange: r,
    showClearButton: o = !0,
    onClear: i,
    children: s,
    validationStatus: a = "none",
    defaultValue: u,
    ...l
  }, d) => {
    const f = At(null), p = d || f, v = (b) => {
      let S = b.target.value;
      l.type !== "text" && l.maxLength && S.length > l.maxLength && (S = S.slice(0, l.maxLength), b.target.value = S), r == null || r(S), n == null || n(b);
    }, w = () => {
      var b;
      r == null || r(""), n == null || n({ target: { value: "" } }), i == null || i(), (b = p.current) == null || b.focus();
    }, h = a === "error" || l["aria-invalid"] === !0, g = W(
      lt.inputWrapper,
      h && "border border-red-600 border-solid bg-red-100",
      e
    ), y = () => a === "success" ? /* @__PURE__ */ m(_e, { name: "check_circle", size: 20, className: "text-green-500", filled: !0 }) : a === "error" ? /* @__PURE__ */ m(_e, { name: "error", size: 20, className: "text-red-500", filled: !0 }) : null, x = t !== void 0 ? t : u;
    return /* @__PURE__ */ z("div", { className: W(lt.wrapper, e), children: [
      /* @__PURE__ */ z("div", { className: g, children: [
        /* @__PURE__ */ m(
          "input",
          {
            type: l.type || "text",
            className: lt.input,
            value: x,
            onChange: v,
            ref: p,
            "aria-invalid": h,
            ...l
          }
        ),
        /* @__PURE__ */ z("div", { className: lt.iconContainer, children: [
          o && x && !l.disabled && !l.readOnly && /* @__PURE__ */ m("div", { className: lt.clearButton, onClick: w, children: /* @__PURE__ */ m(_e, { name: "cancel", size: 20, className: "text-gray-200", filled: !0 }) }),
          a !== "none" && /* @__PURE__ */ m("div", { className: lt.validationIcon, children: y() })
        ] })
      ] }),
      s
    ] });
  }
);
Vc.displayName = "InputContainer";
const Ag = ne(
  ({
    state: e = "enabled",
    helpTextArea: t,
    type: n,
    value: r,
    onChange: o,
    onValueChange: i,
    showClearButton: s = !0,
    onClear: a,
    className: u,
    defaultValue: l,
    isValid: d,
    ...f
  }, p) => {
    const [v, w] = Pe(r);
    be(() => {
      r !== v && w(r);
    }, [r]);
    const h = (b) => {
      i && (f.maxLength && b.length > f.maxLength && (b = b.slice(0, f.maxLength)), i(b), w(b));
    }, g = (b) => {
      o && (f.maxLength && b.target.value.length > f.maxLength && (b.target.value = b.target.value.slice(0, f.maxLength)), o(b), w(b.target.value));
    }, y = () => {
      w(""), i == null || i(""), a == null || a();
    }, E = r !== void 0;
    return /* @__PURE__ */ z("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ m(
        Vc,
        {
          className: u,
          value: E ? r : v,
          defaultValue: E ? void 0 : l,
          onChange: o ? g : void 0,
          onValueChange: i ? h : void 0,
          showClearButton: s,
          onClear: y,
          type: n,
          disabled: e === "disabled" || f.disabled,
          "aria-invalid": e === "error",
          validationStatus: e === "error" ? "error" : d ? "success" : "none",
          ref: p,
          ...f
        }
      ),
      t && /* @__PURE__ */ m(
        ho,
        {
          state: e === "error" ? "error" : "default",
          text: t,
          showCharacterCounter: !1,
          className: "mt-2 border-0 p-0"
        }
      )
    ] });
  }
);
Ag.displayName = "TextInput";
const go = ne(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(
    su,
    {
      ref: n,
      className: W(
        "peer h-[22px] w-[22px] rounded-[4px] border-2 border-gray-100 border-solid bg-white ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "!duration-75",
        "data-[state=checked]:border-0 data-[state=checked]:bg-primary-600 data-[state=checked]:text-white",
        "data-[state=indeterminate]:border-0 data-[state=indeterminate]:bg-primary-600 data-[state=indeterminate]:text-white",
        "disabled:cursor-not-allowed",
        "disabled:data-[state=checked]:bg-gray-100 disabled:data-[state=indeterminate]:bg-gray-100",
        "disabled:data-[state=unchecked]:border-gray-100 disabled:data-[state=unchecked]:bg-gray-50",
        e
      ),
      ...t,
      checked: t.checked,
      "data-state": t.checked === "indeterminate" ? "indeterminate" : t.checked ? "checked" : "unchecked",
      children: /* @__PURE__ */ m(
        cu,
        {
          className: W("flex items-center justify-center text-current"),
          forceMount: t.checked === "indeterminate" ? !0 : void 0,
          children: t.checked === "indeterminate" ? /* @__PURE__ */ m(_e, { name: "check_indeterminate_small", size: 22 }) : /* @__PURE__ */ m(_e, { name: "check", size: 22 })
        }
      )
    }
  )
);
go.displayName = "Checkbox";
const Mg = Dn("flex items-center", {
  variants: {
    hasDescription: {
      true: "flex-col items-start gap-2",
      false: "gap-2"
    }
  },
  defaultVariants: {
    hasDescription: !1
  }
}), Og = ne(
  ({ className: e, label: t, description: n, checkboxProps: r, hasDescription: o, ...i }, s) => {
    const a = !!n, u = () => {
      if (r != null && r.onCheckedChange && r.checked !== "indeterminate") {
        const l = r.checked !== !0;
        r.onCheckedChange(l);
      }
    };
    return /* @__PURE__ */ z("div", { ref: s, className: W(Mg({ hasDescription: a, className: e })), ...i, children: [
      /* @__PURE__ */ z("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ m(go, { ...r }),
        /* @__PURE__ */ m("span", { className: "typography-ui-15m cursor-pointer text-gray-900", onClick: u, children: t })
      ] }),
      n && /* @__PURE__ */ m("div", { className: "pl-[30px]", children: /* @__PURE__ */ m("span", { className: "typography-ui-13r text-gray-400", children: n }) })
    ] });
  }
);
Og.displayName = "CheckItem";
const vo = ne(
  ({ className: e, checked: t, disabled: n, onClick: r, ...o }, i) => /* @__PURE__ */ m(
    "button",
    {
      ref: i,
      type: "button",
      className: W(
        "!duration-75 relative h-[22px] w-[22px] rounded-full border-2 border-solid transition-[border-width,border-color,background-color]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2",
        "focus:outline-none",
        t ? n ? "border-[5px] border-gray-100 bg-white" : "border-[5px] border-primary-600 bg-white ring-primary-500" : n ? "border-gray-100 bg-gray-50" : "border-gray-100 bg-white hover:border-primary-500",
        n ? "cursor-not-allowed" : "cursor-pointer",
        e
      ),
      disabled: n,
      onClick: n ? void 0 : r,
      "data-state": t ? "checked" : "unchecked",
      "aria-checked": t,
      role: "radio",
      ...o
    }
  )
);
vo.displayName = "RadioButton";
const Uc = wn(void 0), Dg = ne(
  ({ defaultValue: e, value: t, onChange: n, name: r, children: o, className: i }, s) => {
    const [a, u] = Pe(e || ""), l = {
      value: t !== void 0 ? t : a,
      onChange: (d) => {
        t === void 0 && u(d), n == null || n(d);
      },
      name: r
    };
    return /* @__PURE__ */ m(Uc.Provider, { value: l, children: /* @__PURE__ */ m("div", { ref: s, className: W("flex flex-col gap-3", i), role: "radiogroup", children: o }) });
  }
);
Dg.displayName = "RadioGroup";
const Ig = ne(
  ({ value: e, children: t, className: n, disabled: r, description: o }, i) => {
    const s = xn(Uc);
    if (!s)
      throw new Error("RadioItem must be used within a RadioGroup");
    const a = s.value === e;
    return /* @__PURE__ */ z("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ z("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ m(
          vo,
          {
            ref: i,
            checked: a,
            disabled: r,
            onClick: () => !r && s.onChange(e),
            name: s.name,
            value: e,
            className: n,
            "aria-checked": a
          }
        ),
        t && /* @__PURE__ */ m(
          "label",
          {
            className: W("typography-ui-15m cursor-pointer", r && "cursor-not-allowed text-gray-300"),
            onClick: () => !r && s.onChange(e),
            children: t
          }
        )
      ] }),
      o && /* @__PURE__ */ m("div", { className: "pl-[30px]", children: /* @__PURE__ */ m("span", { className: W("typography-ui-13r text-gray-400", r && "text-gray-300"), children: o }) })
    ] });
  }
);
Ig.displayName = "RadioItem";
const xv = qp, _g = ne(({ className: e, helpText: t, children: n, selectedValue: r, ...o }, i) => {
  const s = r || n;
  return /* @__PURE__ */ z("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ z(
      ws,
      {
        ref: i,
        className: W(
          "group flex h-[50px] w-full items-center justify-between gap-[4px] rounded-lg bg-gray-30 px-4 py-[13px] transition-colors",
          "typography-ui-17m text-gray-300 focus:outline-none",
          r && "text-gray-700",
          e
        ),
        ...o,
        children: [
          /* @__PURE__ */ m("span", { className: "min-w-0 truncate", children: s }),
          /* @__PURE__ */ z("span", { className: "text-gray-700", children: [
            /* @__PURE__ */ m(
              _e,
              {
                name: "keyboard_arrow_down",
                className: "h-5 w-5 group-data-[state=closed]:block group-data-[state=open]:hidden"
              }
            ),
            /* @__PURE__ */ m(
              _e,
              {
                name: "keyboard_arrow_up",
                className: "h-5 w-5 group-data-[state=open]:block group-data-[state=closed]:hidden"
              }
            )
          ] })
        ]
      }
    ),
    t && /* @__PURE__ */ m(ho, { state: "default", text: t, showCharacterCounter: !1, className: "border-0 p-0" })
  ] });
});
_g.displayName = ws.displayName;
const Ev = Zp, Cv = xs, Sv = Jp, Rv = Qp, kg = ne(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ z(
  As,
  {
    ref: o,
    className: W(
      "flex cursor-default select-none items-center gap-2 rounded-sm px-4 py-3 text-sm outline-none focus:bg-gray-20 data-[state=open]:bg-gray-20 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      "typography-ui-17m text-gray-600",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ m(_e, { name: "chevron_right", className: "ml-auto" })
    ]
  }
));
kg.displayName = As.displayName;
const $g = ne(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Ms,
  {
    ref: n,
    className: W(
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-[--radix-dropdown-menu-content-transform-origin] overflow-hidden rounded-md border bg-white p-1 shadow-lg data-[state=closed]:animate-out data-[state=open]:animate-in",
      e
    ),
    ...t
  }
));
$g.displayName = Ms.displayName;
const Lg = ne(({ className: e, sideOffset: t = 8, align: n = "center", side: r = "bottom", ...o }, i) => /* @__PURE__ */ m(xs, { children: /* @__PURE__ */ m(
  Es,
  {
    ref: i,
    sideOffset: t,
    align: n,
    side: r,
    avoidCollisions: !0,
    collisionPadding: 8,
    className: W(
      "z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] w-[var(--radix-dropdown-menu-trigger-width)] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-white px-0 py-2 shadow-md",
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...o
  }
) }));
Lg.displayName = Es.displayName;
const Fg = ne(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ m(
  Ss,
  {
    ref: r,
    className: W(
      "relative flex cursor-default select-none items-center gap-2 px-4 py-3 outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      "typography-ui-17m text-gray-600 hover:bg-gray-20 focus:bg-gray-20 active:bg-gray-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Fg.displayName = Ss.displayName;
const Bg = ne(({ className: e, children: t, checked: n, ...r }, o) => {
  const i = n === "indeterminate";
  return /* @__PURE__ */ z(
    Rs,
    {
      ref: o,
      className: W(
        "relative flex cursor-default select-none items-center py-3 pr-2 pl-8 outline-none transition-colors hover:bg-gray-20 focus:bg-gray-20 active:bg-gray-50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        "typography-ui-17m text-gray-600",
        e
      ),
      checked: n,
      ...r,
      children: [
        /* @__PURE__ */ m("span", { className: "absolute left-2 flex items-center justify-center", children: /* @__PURE__ */ m(Ns, { children: /* @__PURE__ */ m(
          go,
          {
            className: "h-[18px] w-[18px]",
            checked: i ? "indeterminate" : !0,
            onClick: (s) => {
              s.preventDefault(), s.stopPropagation();
            }
          }
        ) }) }),
        t
      ]
    }
  );
});
Bg.displayName = Rs.displayName;
const Wg = ne(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ z(
  Ts,
  {
    ref: r,
    className: W(
      "relative flex cursor-default select-none items-center py-3 pr-2 pl-8 outline-none transition-colors hover:bg-gray-20 focus:bg-gray-20 active:bg-gray-50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "typography-ui-17m text-gray-600",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ m("span", { className: "absolute left-2 flex items-center justify-center", children: /* @__PURE__ */ m(Ns, { children: /* @__PURE__ */ m(
        vo,
        {
          checked: !0,
          className: "h-[18px] w-[18px]",
          onClick: (o) => {
            o.preventDefault(), o.stopPropagation();
          }
        }
      ) }) }),
      t
    ]
  }
));
Wg.displayName = Ts.displayName;
const Vg = ne(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ m(
  Cs,
  {
    ref: r,
    className: W("typography-ui-17sb px-4 py-3 text-gray-700", t && "pl-8", e),
    ...n
  }
));
Vg.displayName = Cs.displayName;
const Ug = ne(({ className: e, ...t }, n) => /* @__PURE__ */ m(Ps, { ref: n, className: W("-mx-1 my-1 h-px bg-gray-100", e), ...t }));
Ug.displayName = Ps.displayName;
const zg = ({ className: e, ...t }) => /* @__PURE__ */ m("span", { className: W("ml-auto text-gray-400 text-xs tracking-widest", e), ...t });
zg.displayName = "DropdownMenuShortcut";
const Hg = ne(
  ({ className: e, checked: t, defaultChecked: n, disabled: r, onChange: o, ...i }, s) => {
    const [a, u] = Pe(n || !1), l = t !== void 0, d = l ? t : a, f = () => {
      r || (l || u(!a), o == null || o(!d));
    };
    return /* @__PURE__ */ m(
      "div",
      {
        ref: s,
        className: W(
          "relative h-[22px] w-[36px] rounded-[24px] p-[3px] transition-colors",
          d ? "bg-primary-600" : "bg-gray-100",
          r && "opacity-50",
          "cursor-pointer",
          e
        ),
        role: "switch",
        "aria-checked": d,
        tabIndex: r ? -1 : 0,
        onClick: f,
        onKeyDown: (p) => {
          (p.key === "Enter" || p.key === " ") && (p.preventDefault(), f());
        },
        ...i,
        children: /* @__PURE__ */ m(
          "div",
          {
            className: W(
              "h-[16px] w-[16px] rounded-full bg-white shadow-[0px_1px_2px_0px_rgba(0,0,0,0.04)] transition-transform",
              d ? "translate-x-[14px]" : "translate-x-0"
            )
          }
        )
      }
    );
  }
);
Hg.displayName = "Toggle";
const Tv = ({
  type: e,
  showInformationText: t = !1,
  title: n,
  description: r,
  informationText: o = "Information Text",
  children: i,
  buttons: s,
  open: a,
  onOpenChange: u,
  className: l
}) => {
  const d = () => {
    if (e === "single") {
      const f = s[0];
      return /* @__PURE__ */ m(
        fn,
        {
          size: "xl",
          buttonColor: f.variant === "primary" ? "primary" : "gray",
          buttonStyle: f.variant === "primary" ? "contained" : "outlined",
          onClick: f.onClick,
          className: "w-full",
          children: f.label
        }
      );
    }
    return e === "horizontal" ? /* @__PURE__ */ m("div", { className: "flex gap-[12px]", children: s.map((f, p) => /* @__PURE__ */ m(
      fn,
      {
        size: "xl",
        buttonColor: f.variant === "primary" ? "primary" : "gray",
        buttonStyle: f.variant === "primary" ? "contained" : "outlined",
        onClick: f.onClick,
        className: "flex-1",
        children: f.label
      },
      p
    )) }) : /* @__PURE__ */ m("div", { className: "flex flex-col gap-[12px]", children: s.map((f, p) => /* @__PURE__ */ m(
      fn,
      {
        size: "xl",
        buttonColor: f.variant === "primary" ? "primary" : "gray",
        buttonStyle: f.variant === "primary" ? "contained" : "outlined",
        onClick: f.onClick,
        className: "w-full",
        children: f.label
      },
      p
    )) });
  };
  return /* @__PURE__ */ m(sn.Root, { open: a, onOpenChange: u, children: /* @__PURE__ */ z(sn.Portal, { children: [
    /* @__PURE__ */ m(sn.Overlay, { className: "fixed inset-0 z-50 bg-dimmed-80" }),
    /* @__PURE__ */ z(
      sn.Content,
      {
        className: W(
          "fixed right-0 bottom-0 left-0 z-50 mx-auto max-w-sm",
          "rounded-t-2xl bg-white",
          "flex flex-col gap-[32px]",
          "min-w-[360px]",
          l
        ),
        style: { margin: "0 auto" },
        children: [
          /* @__PURE__ */ z("div", { className: "flex flex-col gap-[20px] px-[20px] pt-[24px] pb-0", children: [
            /* @__PURE__ */ z("div", { className: "flex flex-col gap-[8px] px-[4px]", children: [
              /* @__PURE__ */ m("h2", { className: "typography-ui-20sb text-gray-800", children: n }),
              r && /* @__PURE__ */ m("p", { className: "typography-ui-15r text-gray-600", children: r })
            ] }),
            i && /* @__PURE__ */ m("div", { className: "px-[4px]", children: i }),
            t && /* @__PURE__ */ m("div", { className: "px-[4px]", children: /* @__PURE__ */ m(Lc, { children: o }) })
          ] }),
          /* @__PURE__ */ m("div", { className: "px-[20px] pb-[24px]", children: d() })
        ]
      }
    )
  ] }) });
}, jg = 1, Kg = 3e3, zc = 300;
let tr = 0;
const Gg = () => (tr = (tr + 1) % Number.MAX_SAFE_INTEGER, tr.toString()), Hc = wn(null), nr = /* @__PURE__ */ new Map(), rr = (e, t) => {
  if (nr.has(e))
    return;
  const n = setTimeout(() => {
    nr.delete(e), t({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, zc);
  nr.set(e, n);
}, Yg = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, jg)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, Xg = (e, t) => {
  const n = Ot((o) => {
    const i = Gg(), s = (u) => e({
      type: "UPDATE_TOAST",
      toast: { ...u, id: i }
    }), a = () => {
      e({ type: "DISMISS_TOAST", toastId: i }), rr(i, e);
    };
    return e({
      type: "ADD_TOAST",
      toast: {
        ...o,
        id: i,
        open: !0,
        duration: o.duration ?? Kg,
        direction: o.direction ?? "top",
        onOpenChange: (u) => {
          u || a();
        }
      }
    }), {
      id: i,
      dismiss: a,
      update: s
    };
  }, []), r = Ot(
    (o) => {
      e({ type: "DISMISS_TOAST", toastId: o }), o ? rr(o, e) : t.toasts.forEach((i) => {
        rr(i.id, e);
      });
    },
    [t.toasts]
  );
  return { toast: n, dismiss: r };
}, qg = () => {
  const e = xn(Hc);
  if (!e)
    throw new Error("useToast must be used within a ToastProvider");
  return e;
}, Zg = kc, Tr = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(fo, { ref: n, className: W("fixed z-[300] flex max-h-screen w-auto", e), ...t })
);
Tr.displayName = "ToastViewport";
const Qg = Dn(
  W(
    "group pointer-events-auto relative flex items-center justify-center whitespace-pre",
    "rounded-[8px] border bg-white px-[20px] py-[13px] shadow-lg",
    "sm:gap-3 sm:rounded-[8px] sm:px-[20px] sm:py-[13px]",
    "w-max max-w-[320px]",
    // 기본 transition 설정
    "transition-all duration-300 ease-out"
  ),
  {
    variants: {
      variant: {
        default: "border-gray-200 bg-gray-800 px-[20px] py-[13px] text-white"
      },
      direction: {
        top: "",
        bottom: ""
      }
    },
    defaultVariants: {
      variant: "default",
      direction: "top"
    }
  }
), Nr = c.forwardRef(
  ({ className: e, variant: t, direction: n, style: r, open: o, duration: i = 3e3, ...s }, a) => {
    const [u, l] = c.useState(!1), [d, f] = c.useState(o);
    c.useEffect(() => {
      if (o) {
        f(!0);
        const v = setTimeout(() => l(!0), 10);
        return () => clearTimeout(v);
      } else {
        l(!1);
        const v = setTimeout(() => {
          f(!1);
        }, zc);
        return () => clearTimeout(v);
      }
    }, [o]);
    const p = c.useMemo(() => ({
      transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
      transform: u ? "translateY(0)" : n === "bottom" ? "translateY(100%)" : "translateY(-100%)",
      opacity: u ? 1 : 0,
      ...r
    }), [u, n, r]);
    return d ? /* @__PURE__ */ m(
      uo,
      {
        ref: a,
        className: W(Qg({ variant: t, direction: n }), e),
        style: p,
        open: !0,
        duration: i,
        forceMount: !0,
        "data-direction": n,
        ...s
      }
    ) : null;
  }
);
Nr.displayName = "ToastRoot";
const Jg = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  $c,
  {
    ref: n,
    className: W(
      "inline-flex h-7 shrink-0 items-center justify-center rounded-[8px]",
      "border border-gray-200 bg-transparent px-2",
      "transition-colors hover:bg-gray-50",
      "focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2",
      "disabled:pointer-events-none disabled:opacity-50",
      "sm:h-8 sm:rounded-[8px] sm:px-3 ",
      e
    ),
    ...t
  }
));
Jg.displayName = "ToastAction";
const ev = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(po, { ref: n, className: W("leading-none tracking-tight", e), ...t }));
ev.displayName = "ToastTitle";
const Pr = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  mo,
  {
    ref: n,
    className: W("typography-ui-15r text-center leading-relaxed", e),
    ...t
  }
));
Pr.displayName = "ToastDescription";
const tv = ({ children: e }) => {
  const [t, n] = bi(Yg, { toasts: [] }), { toast: r, dismiss: o } = Xg(n, t), i = Dt(
    () => ({
      toasts: t.toasts,
      toast: r,
      dismiss: o
    }),
    [t.toasts, r, o]
  );
  return /* @__PURE__ */ m(Hc.Provider, { value: i, children: e });
}, nv = () => {
  const { toasts: e } = qg(), [t, n] = Pe(!1);
  be(() => {
    n(!0);
  }, []);
  const r = e.filter((s) => s.direction === "top"), o = e.filter((s) => s.direction === "bottom");
  if (!t)
    return null;
  const i = /* @__PURE__ */ z(Zg, { children: [
    r.map(function({ id: s, text: a, ...u }) {
      return /* @__PURE__ */ m(Nr, { ...u, children: /* @__PURE__ */ m("div", { className: "grid gap-1", children: a && /* @__PURE__ */ m(Pr, { children: a }) }) }, s);
    }),
    r.length > 0 && /* @__PURE__ */ m(Tr, { className: "-translate-x-1/2 top-[16px] left-1/2 transform sm:top-4" }),
    o.map(function({ id: s, text: a, ...u }) {
      return /* @__PURE__ */ m(Nr, { ...u, children: /* @__PURE__ */ m("div", { className: "grid gap-1", children: a && /* @__PURE__ */ m(Pr, { children: a }) }) }, s);
    }),
    o.length > 0 && /* @__PURE__ */ m(Tr, { className: "-translate-x-1/2 top-auto bottom-[16px] left-1/2 transform sm:top-auto sm:bottom-4" })
  ] });
  return typeof window < "u" ? $r(i, document.body) : i;
}, Nv = ({ children: e }) => /* @__PURE__ */ z(tv, { children: [
  e,
  /* @__PURE__ */ m(nv, {})
] }), rv = 1, Ar = 6e3, ov = 300;
let or = 0;
const iv = () => (or = (or + 1) % Number.MAX_SAFE_INTEGER, or.toString()), jc = wn(null), ir = /* @__PURE__ */ new Map(), ar = (e, t) => {
  if (ir.has(e))
    return;
  const n = setTimeout(() => {
    ir.delete(e), t({
      type: "REMOVE_SNACKBAR",
      snackbarId: e
    });
  }, Ar);
  ir.set(e, n);
}, av = (e, t) => {
  switch (t.type) {
    case "ADD_SNACKBAR":
      return {
        ...e,
        snackbars: [t.snackbar, ...e.snackbars].slice(0, rv)
      };
    case "UPDATE_SNACKBAR":
      return {
        ...e,
        snackbars: e.snackbars.map((n) => n.id === t.snackbar.id ? { ...n, ...t.snackbar } : n)
      };
    case "DISMISS_SNACKBAR": {
      const { snackbarId: n } = t;
      return {
        ...e,
        snackbars: e.snackbars.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_SNACKBAR":
      return t.snackbarId === void 0 ? {
        ...e,
        snackbars: []
      } : {
        ...e,
        snackbars: e.snackbars.filter((n) => n.id !== t.snackbarId)
      };
  }
}, sv = (e, t) => {
  const n = Ot((o) => {
    const i = iv(), s = (l) => e({
      type: "UPDATE_SNACKBAR",
      snackbar: { ...l, id: i }
    }), a = () => {
      e({ type: "DISMISS_SNACKBAR", snackbarId: i }), ar(i, e);
    };
    e({
      type: "ADD_SNACKBAR",
      snackbar: {
        ...o,
        id: i,
        open: !0,
        duration: o.duration ?? Ar,
        direction: o.direction ?? "top",
        onOpenChange: (l) => {
          l || a();
        }
      }
    });
    const u = o.duration ?? Ar;
    return setTimeout(() => {
      a();
    }, u), {
      id: i,
      dismiss: a,
      update: s
    };
  }, []), r = Ot(
    (o) => {
      e({ type: "DISMISS_SNACKBAR", snackbarId: o }), o ? ar(o, e) : t.snackbars.forEach((i) => {
        ar(i.id, e);
      });
    },
    [t.snackbars]
  );
  return { snackbar: n, dismiss: r };
}, cv = () => {
  const e = xn(jc);
  if (!e)
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  return e;
}, lv = kc, Mr = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m(fo, { ref: n, className: W("fixed z-[100] flex max-h-screen w-auto", e), ...t })
);
Mr.displayName = "SnackbarViewport";
const uv = Dn(
  W(
    "group pointer-events-auto relative flex w-full items-center justify-center gap-2",
    "overflow-hidden rounded-[8px] border bg-white shadow-lg transition-all hover:cursor-auto",
    "min-w-[320px] max-w-full sm:gap-3 sm:rounded-[8px] "
  ),
  {
    variants: {
      variant: {
        default: "border-gray-200 bg-gray-800 text-white"
      },
      direction: {
        top: "",
        bottom: ""
      }
    },
    defaultVariants: {
      variant: "default",
      direction: "top"
    }
  }
), Or = c.forwardRef(({ className: e, variant: t, direction: n, style: r, open: o, duration: i = 3e3, ...s }, a) => {
  const [u, l] = c.useState(!1), [d, f] = c.useState(o);
  c.useEffect(() => {
    if (o) {
      f(!0);
      const v = setTimeout(() => l(!0), 10);
      return () => clearTimeout(v);
    } else {
      l(!1);
      const v = setTimeout(() => {
        f(!1);
      }, ov);
      return () => clearTimeout(v);
    }
  }, [o]);
  const p = c.useMemo(() => ({
    transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
    transform: u ? "translateY(0)" : n === "bottom" ? "translateY(100%)" : "translateY(-100%)",
    opacity: u ? 1 : 0,
    ...r
  }), [u, n, r]);
  return d ? /* @__PURE__ */ m(
    uo,
    {
      ref: a,
      className: W(uv({ variant: t, direction: n }), "min-w-[320px] max-w-full justify-between", e),
      style: p,
      open: !0,
      duration: i,
      forceMount: !0,
      "data-direction": n,
      ...s
    }
  ) : null;
});
Or.displayName = "SnackbarRoot";
const Dr = c.forwardRef(({ buttonText: e, buttonAction: t, onDismiss: n, ...r }, o) => {
  const i = () => {
    t(), n == null || n();
  };
  return /* @__PURE__ */ m(
    "button",
    {
      ref: o,
      className: W("typography-ui-15sb text-primary-700", "h-full px-[20px] py-[13px]"),
      onClick: i,
      type: "button",
      ...r,
      children: e
    }
  );
});
Dr.displayName = "SnackbarAction";
const Ir = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  po,
  {
    ref: n,
    className: W("typography-ui-15sb text-white", "whitespace-nowrap", e),
    ...t
  }
));
Ir.displayName = "SnackbarTitle";
const _r = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  mo,
  {
    ref: n,
    className: W("typography-ui-15r text-gray-200", "whitespace-nowrap", e),
    ...t
  }
));
_r.displayName = "SnackbarDescription";
const vi = ({ children: e }) => /* @__PURE__ */ m("div", { className: "grid py-[13px] pl-[20px]", children: e }), dv = ({ children: e }) => {
  const [t, n] = bi(av, { snackbars: [] }), { snackbar: r, dismiss: o } = sv(n, t), i = Dt(
    () => ({
      snackbars: t.snackbars,
      snackbar: r,
      dismiss: o
    }),
    [t.snackbars, r, o]
  );
  return /* @__PURE__ */ m(jc.Provider, { value: i, children: e });
}, fv = () => {
  const { snackbars: e, dismiss: t } = cv(), [n, r] = Pe(!1);
  be(() => {
    r(!0);
  }, []);
  const o = e.filter((a) => a.direction === "top"), i = e.filter((a) => a.direction === "bottom");
  if (!n)
    return null;
  const s = /* @__PURE__ */ z(lv, { children: [
    o.map(function({ id: a, title: u, description: l, buttonAction: d, buttonText: f, ...p }) {
      return /* @__PURE__ */ z(Or, { ...p, children: [
        /* @__PURE__ */ z(vi, { children: [
          u && /* @__PURE__ */ m(Ir, { children: u }),
          l && /* @__PURE__ */ m(_r, { children: l })
        ] }),
        d && f && /* @__PURE__ */ m(Dr, { buttonText: f, buttonAction: d, onDismiss: () => t(a) })
      ] }, a);
    }),
    o.length > 0 && /* @__PURE__ */ m(Mr, { className: "-translate-x-1/2 top-[16px] left-1/2 transform sm:top-4" }),
    i.map(function({ id: a, title: u, description: l, buttonAction: d, buttonText: f, ...p }) {
      return /* @__PURE__ */ z(Or, { ...p, children: [
        /* @__PURE__ */ z(vi, { children: [
          u && /* @__PURE__ */ m(Ir, { children: u }),
          l && /* @__PURE__ */ m(_r, { children: l })
        ] }),
        d && f && /* @__PURE__ */ m(Dr, { buttonText: f, buttonAction: d, onDismiss: () => t(a) })
      ] }, a);
    }),
    i.length > 0 && /* @__PURE__ */ m(Mr, { className: "-translate-x-1/2 top-auto bottom-[16px] left-1/2 transform sm:top-auto sm:bottom-4" })
  ] });
  return typeof window < "u" ? $r(s, document.body) : s;
}, Pv = ({ children: e }) => /* @__PURE__ */ z(dv, { children: [
  e,
  /* @__PURE__ */ m(fv, {})
] });
export {
  $l as ActionSheet,
  Eg as ActionSheetContent,
  wi as ActionSheetContext,
  Cg as ActionSheetItem,
  Fc as ActionSheetItemLabel,
  Ai as ActionSheetTrigger,
  Bc as AreaContainer,
  Tv as BottomSheet,
  fn as Button,
  Og as CheckItem,
  go as Checkbox,
  xv as DropdownMenu,
  Bg as DropdownMenuCheckboxItem,
  Lg as DropdownMenuContent,
  Ev as DropdownMenuGroup,
  Fg as DropdownMenuItem,
  Vg as DropdownMenuLabel,
  Cv as DropdownMenuPortal,
  Rv as DropdownMenuRadioGroup,
  Wg as DropdownMenuRadioItem,
  Ug as DropdownMenuSeparator,
  zg as DropdownMenuShortcut,
  Sv as DropdownMenuSub,
  $g as DropdownMenuSubContent,
  kg as DropdownMenuSubTrigger,
  _g as DropdownMenuTrigger,
  ho as HelpTextArea,
  Lc as InformationText,
  Vc as InputContainer,
  vo as RadioButton,
  Dg as RadioGroup,
  Ig as RadioItem,
  ov as SNACKBAR_ANIMATION_DURATION,
  Or as Snackbar,
  Dr as SnackbarAction,
  Pv as SnackbarContainer,
  vi as SnackbarContentWrapper,
  _r as SnackbarDescription,
  Ir as SnackbarTitle,
  Mr as SnackbarViewport,
  zc as TOAST_ANIMATION_DURATION,
  Pg as TextArea,
  Ag as TextInput,
  Nr as Toast,
  Jg as ToastAction,
  Nv as ToastContainer,
  Pr as ToastDescription,
  tv as ToastProvider,
  ev as ToastTitle,
  Tr as ToastViewport,
  Hg as Toggle,
  Sg as buttonVariants,
  kl as useActionSheet,
  xi as useActionSheetContext,
  cv as useSnackbar,
  qg as useToast
};
//# sourceMappingURL=index.es.js.map
